(function() {
  'use strict';

  if(jQuery(window).width() > 641){
  	jQuery('.mobile-dd').remove();
    jQuery('.desk-dd').show();
  } else {
  	jQuery('.desk-dd').remove();
    jQuery('.mobile-dd').show();
  }
  
  /* Init slideshow on index page */
  var _, controls, dots, slideshow;

  _ = window.belovedLodash;

  slideshow = $('#js-slideshow');

  controls = $('#js-slideshow-controls');

  if (slideshow.length === 0) {
    return;
  }

  if (slideshow.children().length <= 1) {
    return;
  }


  /* Init slideshow */

  slideshow.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
    customPaging: '',
    pauseOnDotsHover: true,
    variableWidth: false,
    mobileFirst: true,
    fade: true,
    adaptiveHeight: true
  });


  /* Activate slideshow controls */

  controls.find('button').addClass('is-active');

  controls.asEventStream('click', '.is-active', function(evt) {
    return $(evt.currentTarget).attr('data-action') || '';
  }).onValue(function(action) {
    return slideshow.slick(_.camelCase('slick ' + action));
  });


  /* Init slideshow dots */

  $('#js-slideshow-dots').addClass('are-visible');

  dots = $('#js-slideshow-dots .js-slideshow-dot');

  slideshow.on('beforeChange', function(evt, slick, currentSlide, nextSlide) {
    dots.eq(nextSlide).attr('checked', true);
  });

  dots.on('change', function(evt) {
    slideshow.slick('slickGoTo', $(evt.delegateTarget).attr('data-slide-index') || 0);
  });

}).call(this);
;

(function() {
  'use strict';

  /* Init slideshow on index page */
  var initNewArrivals;

  initNewArrivals = function(newArrivalsSelector, eventName) {
    var newArrivals;
    eventName = eventName || 'newArrivals:men';
    newArrivalsSelector = newArrivalsSelector || '.js-new-arrivals:first';
    newArrivals = $(newArrivalsSelector);
    if (newArrivals.length === 0) {
      return;
    }
    $('.js-new-arrivals').show();
    return newArrivals.slick({
      infinite: true,
      slidesToShow: 4,
      arrows: true,
      slidesToScroll: 4,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  };

  initNewArrivals();

  $(document).on('scroll', function() {
    $(document).trigger('newArrivals:men');
    $(document).trigger('newArrivals:women');
  });

  window.beloved.fn.newArrivals = {
    init: initNewArrivals
  };

}).call(this);
;

(function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  /* Render YouTube video in slide */
  var _, renderVideo, slideshow;

  _ = window.belovedLodash;

  slideshow = $('#js-slideshow');

  if (slideshow.length === 0) {
    return;
  }

  renderVideo = function(slide, videoURL) {
    var videoID;
    if (!videoURL) {
      return;
    }
    videoID = (function() {
      var url;
      url = new URI(videoURL);
      if (_.includes(url.path(), 'watch')) {
        return _.get(url.search(true), 'v', '');
      }
      if (_.includes(url.hostname(), 'youtu.be')) {
        return url.filename();
      }
      if (_.includes(url.path(), 'embed')) {
        return url.filename();
      }
      return '';
    })();
    if (!videoID) {
      //console.log('No YouTube video ID found');
      return;
    }
    slide.css('background-image', ["url('", 'https://img.youtube.com/vi/', videoID, '/maxresdefault.jpg', "')"].join(''));
    slide.closest('.js-slide').append($(document.createElement('div')).attr({
      id: 'js-video-' + videoID
    }));
    window.onYouTubeIframeAPIReady = function() {
      var onPlayerReady, player;
      slide.closest('.js-slide').append($(document.createElement('div')).attr({
        id: 'js-video-poster-' + videoID,
        "class": 'SlideshowItem-videoPoster'
      }).css('background-image', ["url('", 'https://img.youtube.com/vi/', videoID, '/maxresdefault.jpg', "')"].join(''))).append($(document.createElement('div')).attr({
        id: 'js-video-play-button-' + videoID,
        "class": 'SlideshowItem-playButton u-playButton'
      }));
      onPlayerReady = function(event) {
        return $('#js-video-play-button-' + videoID).click(function(evt) {
          evt.preventDefault();
          event.target.playVideo();
          $(evt.delegateTarget).addClass('is-hidden');
          $('#js-video-poster-' + videoID).addClass('is-hidden');
        });
      };
      player = new window.YT.Player('js-video-' + videoID, {
        width: slideshow.width() + '',
        height: slideshow.height() + '',
        videoId: videoID,
        playerVars: {
          autohide: 1,
          disablekb: 1,
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
          showinfo: 0
        },
        events: {
          'onReady': onPlayerReady
        }
      });
    };
    $('body').append($(document.createElement('script')).attr('src', 'https://www.youtube.com/iframe_api'));
  };

  slideshow.find('.js-slide-image-placeholder[data-youtube-video]').each(function(index, element) {
    var videoURL;
    videoURL = $(element).attr('data-youtube-video');
    if (!videoURL) {
      return;
    }
    if (!window.Modernizr.mq('(min-width: 641px)')) {
      return;
    }
    renderVideo($(element), videoURL);
  });

}).call(this);
;

(function() {
  'use strict';

  /* Make index banner video appear only on desktops */
  var createVideoElement, videoImages;

  createVideoElement = function(index, element) {
    var mp4, ogv, poster, videoElement, videoImage;
    videoImage = $(element);
    poster = videoImage.attr('data-video-poster');
    mp4 = (function() {
      var source;
      source = videoImage.attr('data-video-mp4');
      if (source) {
        return $(document.createElement('source')).attr({
          'src': source,
          'type': 'video/mp4'
        });
      }
    })();
    ogv = (function() {
      var source;
      source = videoImage.attr('data-video-ogv');
      if (source) {
        return $(document.createElement('source')).attr({
          'src': source,
          'type': 'video/ogg'
        });
      }
    })();
    videoElement = $(document.createElement('video')).attr({
      'class': 'IndexVideoBanner-video',
      'autoplay': 'autoplay',
      'loop': true,
      'muted': true,
      'poster': poster
    });
    if (mp4 != null) {
      videoElement.append(mp4);
    }
    if (ogv != null) {
      videoElement.append(ogv);
    }
    videoImage.parent().prepend(videoElement);
    videoImage.remove();
  };

  videoImages = $('#js-video-banner');

  if (videoImages.length === 0) {
    return;
  }

  if (window.Modernizr.mq('(max-width: 1024px)')) {
    return;
  }

  videoImages.each(createVideoElement);

}).call(this);
;
/* 18-11-2016 for active menu added by DD*/
(function() {
  var _, headerMenu,menuList;
  headerMenu = $('#js-header');
  
  menuList = headerMenu.find('.HeaderMenu-list ');
  
  if ($(window).width() <= 767) {
    return;
  }
  
  if(menuList.length < 0){
    return;
  }
  
  menuList.find('li').each(function(){
    if($(this).find('.is-active').length > 0){
      $(this).find('.js-header-menu-link.HeaderMenu-listItemLink ').addClass('is-active');
    }
  });
  
}).call(this);
;
(function() {
  var _, headerMenu,menuList;
  headerMenu = $('.js-offcanvas');
  
  menuList = headerMenu.find('ul.OffcanvasNav-items ');
  
  if ($(window).width() > 767) {
    return;
  }
  
  if(menuList.length < 0){
    return;
  }
  
  menuList.find('li').each(function(){
    if($(this).find('.is-active').length > 0){
      $(this).find('.js-offcanvas-nav-top-link.OffcanvasNav-itemLink').addClass('is-active');
    }
  });
  
}).call(this);
;


(function() {
  'use strict';

  /* Expand/collapse filter menu on collection page */
  var _, collapseFilterMenu, content, expandFilterMenu, expander, initExpander, menu, section, tagCount;

  _ = window.belovedLodash;

  menu = $('#js-filter-menu');

  expander = $('#js-filter-menu-expander');

  content = $('#js-filter-menu-content');

  expandFilterMenu = function() {
    if (!$(menu).is(":visible")) {
      return $(menu).velocity({
        p: 'slideDown',
        o: {
          duration: 500,
          easing: 'easeInOut',
          complete: function() {
            return expander.addClass('is-expanded');
          }
        }
      });
    }
  };

  collapseFilterMenu = function() {
    return $(menu).velocity({
      p: 'slideUp',
      o: {
        duration: 500,
        easing: 'easeInOut',
        complete: function() {
          return expander.removeClass('is-expanded');
        }
      }
    });
  };

  initExpander = function() {
    if (menu.length > 0 && expander.length > 0 && content.length > 0) {
      return expander.click(function(evt) {
        evt.preventDefault();
        if (expander.hasClass('is-expanded')) {
          return collapseFilterMenu();
        } else {
          return expandFilterMenu();
        }
      });
    }
  };

  initExpander();


  /* Expand filter menu automatically if current tag count is more than 2 */

  tagCount = _.parseInt($('#js-filter-menu').attr('data-tag-count'));

  if (_.isFinite(tagCount)) {
    expandFilterMenu();
  }


  /* Expand filter menu on iPad and bigger screens */

  if (window.Modernizr.mq('(min-width: 48em)')) {
    expandFilterMenu();
  }

  window.beloved.fn.filterMenu = {
    expand: expandFilterMenu,
    collapse: expandFilterMenu
  };

  section = $('#js-filter-menu .filter-group h4');

  section.off('click').on('click', function() {
    var elem;
    elem = $(this);
    return elem.toggleClass('collapsed');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Activate thumbnail links on product page */
  var activateThumbLink;

  activateThumbLink = function(index, element) {
    var featuredImage, thumbLink;
    thumbLink = $(element);
    featuredImage = thumbLink.parents('.js-product-images').find('.js-featured-image');
    if (featuredImage.length === 0) {
      return;
    }
    thumbLink.click(function(evt) {
      var newImage, oldImage;
      evt.preventDefault();
      oldImage = featuredImage.find('.js-featured-image-placeholder').first();
      if (oldImage.length === 0) {
        return;
      }
      if (oldImage.attr('data-image-id') === thumbLink.attr('data-image-id')) {
        return;
      }
      newImage = $(document.createElement('div')).attr({
        'class': ['js-featured-image-placeholder', 'Product-featuredImagePlaceholder', 'lazyload', 'is-newlyAdded'].join(' '),
        'data-bgset': thumbLink.attr('data-src'),
        'data-image-id': thumbLink.attr('data-image-id'),
        'data-sizes': 'auto'
      });
      featuredImage.attr({
        'href': thumbLink.attr('href')
      }).html(newImage);
    });
  };

  $('.js-product-images .js-thumb-link').each(activateThumbLink);

}).call(this);
;

(function() {
  'use strict';

  /* Lazyload homepage images */
  var initLazyLoad;

  initLazyLoad = function() {
    var _, getSizedImageUrl, placeholders, setImageSizes;
    _ = window.belovedLodash;
    getSizedImageUrl = _.get(window, 'beloved.fn.getSizedImageUrl', null);
    if (!getSizedImageUrl) {
      //console.log('Size Image Url function is not defined');
      return;
    }
    placeholders = $('.js-index-image-placeholder');
    if (placeholders.length === 0) {
      return;
    }
    setImageSizes = function(index, element) {
      var sizeNames, sizes;
      sizeNames = {
        'small': 100,
        'compact': 160,
        'medium': 240,
        'large': 480,
        'grande': 600,
        '1024x1024': 1024,
        '1190x1190': 1190
      };
      sizes = _.map(sizeNames, function(width, sizeName) {
        return getSizedImageUrl($(element).attr('data-bg-image'), sizeName) + ' ' + Math.floor(width * 0.75) + 'w';
      }).join(',');
      $(element).attr({
        'data-sizes': 'auto',
        'data-bgset': sizes
      }).addClass('lazyload');
    };
    return placeholders.each(setImageSizes);
  };

  initLazyLoad();

  window.beloved.fn.lazyLoad = {
    init: initLazyLoad
  };

}).call(this);
;

(function() {
  'use strict';

  /* Render Swiftype results */
  var _, clearResults, container, getSizedImageUrl, inputField, postRender, renderResults;

  _ = window.belovedLodash;

  container = $('.js-swiftype-results');

  inputField = $('.js-swiftype-input');

  getSizedImageUrl = _.get(window, 'beloved.fn.getSizedImageUrl', null);

  renderResults = function(documentType, item) {
    var template, templateData;
    template = _.get(window, 'beloved.templates.swiftypeItem', '<!-- Template not found -->');
    templateData = {
      image: (function() {
        if (!item.image) {
          return null;
        }
        if (item.type !== 'product') {
          return null;
        }
        if (getSizedImageUrl) {
          return getSizedImageUrl(item.image, 'small');
        }
        return item.image;
      })(),
      title: item.title,
      url: item.url
    };
    return template(templateData);
  };

  postRender = function(data) {
    var template, templateData;
    $(document).trigger('beloved:search_results');
    template = _.get(window, 'beloved.templates.swiftypeHeader', '<!-- Template not found -->');
    templateData = {
      totalCount: _.get(data, 'info.page.total_result_count', 0),
      query: _.get(data, 'info.page.query', '')
    };
//     if($(window).width()>767){
      
//     }
    window.location = '/search?q='+_.get(data, 'info.page.query', '');
//     $('.outer-popup,.outer-popup-overlay').show();
    return container.prepend(template(templateData)).removeClass('isHidden');
  };


  /* set up Swiftype autocomplete */

  $('.js-swiftype-autocomplete').swiftype({
    engineKey: 'KaeZ64tBMkqMTcmByzdd',
    renderFunction: function(document_type, item) {
      var image, ref, ref1;
      if (item.type === 'product' && item.image) {
        image = ((ref = window.beloved) != null ? (ref1 = ref.fn) != null ? typeof ref1.getSizedImageUrl === "function" ? ref1.getSizedImageUrl(item.image, 'thumb') : void 0 : void 0 : void 0) || item.image;
        return "<div class=\"product-image\" style=\"background-image: url('" + image + "');\"></div>\n<p class=\"title\">" + item.title + "</p>";
      }
      return "<p class='title'>" + item.title + "</p>";
    }
  });


  /* set up Swiftype search */

  inputField.swiftypeSearch({
    engineKey: "KaeZ64tBMkqMTcmByzdd",
    resultContainingElement: container,
    perPage: 5,
    renderFunction: renderResults,
    postRenderFunction: postRender
  });


  /* clear results when offcanvas drawers are closed */

  clearResults = function() {
    window.location.hash = '';
    $('.js-swiftype-input').val('');
  };

  $(document).on('beloved:hide_offcanvas', clearResults);
  
  $(document).keyup(function(e){
    if (e.keyCode === 27) {
      $('.outer-popup').hide();
      $('.outer-popup-overlay').hide();
      window.location.hash = '';
    }
  });
  
  $('.outer-popup-overlay , .outer-popup .close-btn').click(function(){
    $('.outer-popup').hide();
    $('.outer-popup-overlay').hide();
    window.location.hash = '';
  });


  /* Open drawer if Swiftype query is in URL */

  if (_.contains(window.location.hash, 'stq=')) {
    $(document).trigger('beloved:toggle_drawer', ['search', 'open']);
  }

  return;

}).call(this);
;

(function() {
  'use strict';

  /* Collection Sorting */
  var _, collectionSortBy, currentParams, queryParams, ref, ref1;

  _ = window.belovedLodash;

  collectionSortBy = (ref = window.beloved) != null ? (ref1 = ref.collection) != null ? ref1.sort_by : void 0 : void 0;

  if (collectionSortBy != null) {
    currentParams = location.search.substr(1).split('&');
    queryParams = (function() {
      if (currentParams.length > 1) {
        return _.chain(currentParams).reduce(function(result, couple) {
          var key, keyValue, value;
          keyValue = couple.split('=');
          if (keyValue.length > 1) {
            key = window.decodeURIComponent(keyValue[0]);
            value = window.decodeURIComponent(keyValue[1]);
            result[key] = value;
            return result;
          }
        }, {}).value();
      }
      return {};
    })();
    $('.js-sort-by').val(collectionSortBy).change(function(evt) {
      var newParams, newValue;
      newValue = $(evt.delegateTarget).val();
      newParams = _.merge(queryParams, {
        'sort_by': newValue
      });
      location.search = jQuery.param(newParams);
    });
  }

}).call(this);
;

(function() {
  'use strict';

  /* Init sizechart thumb and lightbox */
  var _, getSizedImageUrl, sizechartLink, sizechartThumb;

  _ = window.belovedLodash;

  sizechartLink = $('.js-size-chart-link-no-thumb');

  if (sizechartLink.length === 0) {
    return;
  }

  getSizedImageUrl = _.get(window.beloved, 'fn.getSizedImageUrl', null);

  if (!getSizedImageUrl) {
    return;
  }

  sizechartThumb = getSizedImageUrl(sizechartLink.attr('href'), 'grande');

  sizechartLink.append($(document.createElement('img')).attr({
    'class': 'SizeChart-thumb',
    'src': sizechartThumb,
    'alt': ''
  }));

  sizechartLink.magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });

  $('.js-size-chart-link-no-thumb').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });

  $('.js-size-chart-link').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });
  
}).call(this);
;

(function() {
  'use strict';

  /* Show size availability under product thumbnail */
  var _, renderSizeList;

  _ = window.belovedLodash;

  renderSizeList = function(group, titleText) {
    var items, title;
    if (group == null) {
      return '';
    }
    items = _.chain(group).uniq(function(size) {
      return size.name;
    }).map(function(size, index, allSizes) {
      var positionClass;
      positionClass = (function() {
        if (index === 0 && index === allSizes.length - 1) {
          return 'is-first is-last';
        }
        if (index === allSizes.length - 1) {
          return 'is-last';
        }
        if (index === 0) {
          return 'is-first';
        }
        return '';
      })();
      return $(document.createElement('div')).attr({
        'class': "ThumbAvail-item is-" + size.status + " " + positionClass
      }).text(size.name);
    }).value();
    title = $(document.createElement('div')).attr({
      'class': 'ThumbAvail-categoryTitle'
    }).text(titleText + ":");
    if (items.length > 0) {
      return $(document.createElement('div')).attr({
        'class': 'ThumbAvail-section'
      }).append(title).append(items);
    }
    return '';
  };

  $('.js-size-availability').each(function(index, element) {
    var groups, optionNames, sizePosition, variants;
    optionNames = JSON.parse($(element).attr('data-options'));
    variants = JSON.parse($(element).attr('data-variants'));
    sizePosition = _.findIndex(optionNames, function(name) {
      return _.contains(name.toLowerCase(), 'size');
    }) + 1;
    if (!sizePosition) {
      return;
    }
    groups = _.chain(variants).reject(function(variant) {

      /* Filter out Buy X app variants */
      return _.includes(variant.title, '% Off');
    }).map(function(variant) {
      return {
        name: variant["option" + sizePosition],
        status: (function() {
          if (variant.inventory_management !== 'shopify') {
            return 'untracked';
          }
          if (variant.inventory_quantity >= 5) {
            return 'inStock';
          }
          if (variant.inventory_quantity < 5 && variant.inventory_quantity > 0) {
            return 'lowStock';
          }
          if (variant.inventory_policy === 'deny') {
            return 'soldOut';
          }
          return 'madeToOrder';
        })()
      };
    }).groupBy(function(size) {
      if (size.status === 'inStock' || size.status === 'lowStock') {
        return 'available';
      }
      return size.status;
    }).value();
    $(element).append(renderSizeList(groups.available, 'Available for shipment'));
  });

}).call(this);
;

(function() {
  'use strict';

  /* Toggle product description tabs */
  var initProductDescTab, tabContents, tabs;

  tabs = $('.js-product-tab');

  tabContents = $('.js-product-tab-content');

  if (tabs.length === 0 && tabContents.length === 0) {
    return;
  }

  initProductDescTab = function(evt) {
    var tab, tabContent, tabHandle;
    tab = $(evt.delegateTarget);
    tabHandle = tab.attr('data-tab-handle');
    tabContent = tabContents.filter("[data-tab-handle='" + tabHandle + "']");
    if (tabContent.length === 0) {
      return;
    }
    tabs.not(tab).removeClass('is-active');
    tabContents.not(tabContent).removeClass('is-active').velocity({
      p: 'slideUp',
      o: {
        duration: 300,
        easing: 'easeInOut'
      }
    });
    tab.addClass('is-active');
    tabContent.addClass('is-active').velocity({
      p: 'slideDown',
      o: {
        duration: 300,
        easing: 'easeInOut'
      }
    });
  };

  tabs.click(initProductDescTab);

}).call(this);
;

(function() {
  'use strict';

  /* Populate "Also available as" section */
  var _, getProducts, getSwiftypeResults, productHandle, productTitle, productType, renderProducts, shopUrl;

  _ = window.belovedLodash;

  if ($('#js-also-available').length === 0) {
    return;
  }

  productHandle = _.get(window, 'beloved.product.handle', '') || '';

  productTitle = _.get(window, 'beloved.product.title', '') || '';

  productType = _.get(window, 'beloved.product.type', '') || '';

  shopUrl = _.get(window, 'beloved.shop.url', '');

  if (!productHandle) {
    return;
  }

  if (_.includes(_.kebabCase(productType), 'museum')) {
    return;
  }

  getSwiftypeResults = function() {
    return new Promise(function(resolve, reject) {
      var query; 
//       query =_.kebabCase(productTitle).replace(/-adult/, '').replace(/-men.?s/, '').replace(/-women.?s/, '').replace(/-kid.?s/, '').replace('-pocket-tee', '').replace('-tee', '').replace('-belovesie', '').replace('-sweatshirt', '').replace('-muscle-tank', '').replace('-tank', '').replace('-croptop', '').replace('-zip-up', '').replace('-hoodie', '').replace('-raglan-sleeves', '').replace('-raglan', '').replace('-leggings', '').replace('-v-neck', '').replace('-bucket-hat', '').replace('-hat', '').replace('-necklace', '').replace('-crew-socks', '').replace('-sublimated', '').replace('-pillow-case', '').replace('-blanket', '').replace('-i-phone-case', '').replace('-ring', '').replace('-mask', '').replace('-joggers', '').replace('-jogger', '').replace('-free', '').replace('-yoga-pants', '').replace('-ready-to-ship', '').replace('custom', '').replace('-top', '').replace('-high-tops','').replace('-highs','').replace('-cotton','');

      query =_.kebabCase(productTitle).replace(/-adult/, '').replace(/-men.?s/, '').replace(/-women.?s/, '').replace(/-kid.?s/, '').replace('-pocket-tee', '').replace('-tee', '').replace('-belovesie', '').replace('-sweatshirt', '').replace('-shirt', '').replace('-muscle-tank', '').replace('-tank', '').replace('-croptop', '').replace('-crop', '').replace('-zip-up', '').replace('-hoodie', '').replace('-raglan-sleeves', '').replace('-men-raglan', '').replace('-sleeves', '').replace('-sleeve', '').replace('-raglan', '').replace('-leggings', '').replace('-v-neck', '').replace('-bucket-hat', '').replace('-hat', '').replace('-necklace', '').replace('-crew-socks', '').replace('-crew-tee', '').replace('-socks', '').replace('-sublimated', '').replace('-pillow-case', '').replace('-pillow', '').replace('-pillows', '').replace('-blanket', '').replace('-i-phone-case', '').replace('-case', '').replace('-ring', '').replace('-mask', '').replace('-joggers', '').replace('-jogger', '').replace('-free', '').replace('-yoga-pants', '').replace('-yoga-mat', '').replace('-pants', '').replace('-ready-to-ship', '').replace('custom', '').replace('-top', '').replace('-high-tops','').replace('-highs','').replace('-cotton','').replace('-apron','').replace('-athletic','').replace('-classic-backpack','').replace('-tech-backpack','').replace('-backpack','').replace('-board-shorts','').replace('-shorts','').replace('-canvas-wraps','').replace('-dream','').replace('-dress','').replace('-duvet-cover','').replace('-edm-gear','').replace('-fidget-spinner','').replace('-flip-flops','').replace('-graphic','').replace('-gift-card','').replace('-handbag','').replace('-jewelry','').replace('-kids','').replace('-long','').replace('-mug','').replace('-mystery-box','').replace('-notebook','').replace('-one-piece-swimsuit','').replace('-pencil','').replace('-rubber','').replace('-shower-curtain','').replace('-slippers','').replace('-snapback','').replace('-sticker','').replace('-strapback','').replace('-cap','').replace('-elite','').replace('-sunglasses','').replace('-tapestry','').replace('-tall','').replace('-throw','').replace('-tracksuit','').replace('-v-necks','').replace('-weekend','').replace('-high-legged','').replace('-high','').replace('-legged','').replace('-legs','-chect').replace('-sports','').replace('-bra','').replace('-vintage','').replace('-ts','').replace('-swim-trunks','');
      
      //console.log("Swiftype query: design-" + query);
      //       11-1-2017
      $.ajax({
        'type': 'GET',
        'url': '/search.json?q=design-'+query,
        'dataType': "html",
        'success': function(data){
          $('#extra_img').html($(data).find('#appnd_html ul'));
          $('#extra_img ul').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
          });

          $('.product-right-bottom-dd .product-img a').each(function(){
            if($(this).hasClass('active')){
              return;
            }
            if($('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length <= 0 && $('#extra_img').find('.'+$.trim($(this).attr('class'))+'-cotton a').length <= 0 ) {
              $(this).addClass('dd-hide');
            }
          });

          $('.product-right-tabs .tab-content').removeClass('current');
          $('.product-right-tabs ul').find('li').removeClass('current');
          $('.product-right-tabs .tab-content').each(function(){
            if($(this).find('.active').length > 0){
              $(this).addClass('current');
              $('.product-right-tabs ul').find('li[data-tab='+$(this).attr('id')+']').addClass('current');
            }
            if($(this).find('a').length != $(this).find('.dd-hide').length){
              $('.product-right-tabs ul').find('li[data-tab='+$(this).attr('id')+']').css('display','inline-block');
            }
          });
          $('.product-right-tabs').show();

          //           load product on click          
          $('#extra_img li a').click(function(e){
            e.preventDefault();
            
            var pname = $.trim($('.Product-title.product_name').text()).replace(/\ /g, '-').replace("'","");
            pname = pname.toLowerCase();
            var get_prod = $(this).attr('href');
            
            //console.log(get_prod.replace('/products/','')+'=='+pname);

            if(get_prod.replace('/products/','')== pname){
              return;
            }

            $.ajax({
              'type': 'GET',
              'url': get_prod,
              'success': function(dt){
                $('.medium-5.columns.omega').html($(dt).find('.medium-5.columns.omega').html());
                $('.Product-featuredImage').html($(dt).find('.Product-featuredImage').html());
                $('.Product-imageThumbs').empty();
                $('.Product-imageThumbs').html($(dt).find('.Product-imageThumbs').html());
                $('.image_popup').empty();
                $('.image_popup').html($(dt).find('.image_popup').html());
                $('.product_seen').html($(dt).find('.product_seen').html());
                $('#stamped-main-widget').replaceWith($(dt).find('#stamped-main-widget'));
                StampedFn.loadBadges();

                var json_obj = $(dt).find('[id^=product-json-]');
                var myObj= jQuery.parseJSON(JSON.stringify(json_obj.html()));
                myObj = JSON.parse(myObj);
                //console.log(myObj);
                
                $(window).load(function() {
                initOptionSelectors(myObj);
                })
                
                function initOptionSelectors(product) {
                  if(product.options.length >= 1){
                    var $form = $('.product_form');
                    //Save default button text
                    var $btn = $('input[type="submit"]', $form);
                    $btn.data('defText', $btn.val());

                    //Split dropdowns into multiple
                    var dropdownID = $('select[name=id]', $form).attr('id');
                    var optionSelectors = new Shopify.OptionSelectors(dropdownID, { product: product, onVariantSelected: selectCallback, enableHistoryState: false });

                    if(product.options.length == 1 && product.options[0] != 'Title') {
                      // Add label if only one product option and it isn't 'Title'.
                      $('<label>').html(product.options[0]).attr('for', $form.find('.single-option-selector:eq(0)').attr('id')).prependTo('.selector-wrapper:eq(0)', $form);
                    }
                    //Hide label for the hidden select, when more than one dropdown created
                    if($('.productoptions .selector-wrapper', $form).length > 0) {
                      $('.productoptions label[for="'+dropdownID+'"]', $form).hide();
                    }
                    //Style all visible select dropdowns
                    $('select:not([name=id])', $form).selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');
                  }

                }
                ajx_popup();
              }
            });
          });

          $('.product-right-bottom-dd .product-img a').click(function(e){
            e.preventDefault();
            if($(this).hasClass('active')){
              return;
            }
            var top_url = $(location).attr('href'); 

            if(top_url.indexOf('women')>0){
              if($('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length > 0){
                $('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').first().trigger('click');
              }else{
                $('#extra_img').find('.'+$.trim($(this).attr('class'))+'-cotton a').first().trigger('click');
              }
            }else{
              var thisClass = $.trim($(this).attr('class'));
              var a_lgth = 0;
              
              if($('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length > 0){
              	a_lgth = $('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length -1 ;
              }
              var common_class = $.trim($(this).attr('class'));
              
              $('#extra_img').find('div[class*="'+common_class+'"] a').each(function(i){
                
                if($(this).find('span').text().indexOf(' men')>0 || $(this).find('span').text().indexOf(' Men')>0){
                  $(this).trigger('click');
                  return false;
                }else if(i == a_lgth) {
                  
                  if($('#extra_img').find('.'+thisClass+' a').length > 0){
                    $('#extra_img').find('.'+thisClass+' a').first().trigger('click'); 
                  }else{
                    $('#extra_img').find('.'+thisClass+'-cotton a').first().trigger('click'); 
                  }
                }
              });
            }
          });

          //           for select option
          var tempi = 0;

          $('#extra_img div[class*="p-"]').each(function(){

            var pic_img = $(this).find('.ProductThumb-imagePlaceholder:first-child').attr('data-bgset').split(',')[0];
            var match_text = $('.product-img .active').attr('class').toLowerCase().split('p-')[1].split(' ')[0];

            var match_class = $.trim($(this).find('.title').text().toLowerCase());
//             if(match_class.indexOf('ready to ship') >= 0){
//               match_class = $.trim(match_class.split('-')[0]);
//             }
            var mClass = $.trim($('.Product-title.product_name.mobile_hide').text().toLowerCase());

            var thisClass = $(this).attr('class').toLowerCase();
            var tClass = thisClass.split('p-')[1].split(' ')[0];
            var appClass = '';
            var top_url = $(location).attr('href'); 
            var mencheck = 0;
            
            if(top_url.indexOf('women')>0){
              mencheck = 0;
            }else{
              mencheck = 1;
            }
            var swim_class ='';
            var dd_rts ='';
            
            var hide_txt = _.kebabCase(match_class);
            if($('#pType').hasClass('swim-option')){
              if(match_class.indexOf('high legged') >= 0 ){
                swim_class = "high_legged";
              }else{
                swim_class = "classic_swim";
              }
            }
            if(match_class.indexOf('ready to ship') >= 0 ){
              dd_rts = 'dd-rts="yes"';
            } else {
              dd_rts = 'dd-rts="no"';
            }
            
            if(tClass.indexOf(match_text) >= 0){
              if(match_class == mClass && tempi == 0){
                  tempi = 1;
                  appClass = 'selected icon-checkmark';
              }
              //console.log( mClass);
              $('#pType').append('<label class="'+appClass+' p-'+tClass+' '+swim_class+'" '+dd_rts+' style="display:block"><img src="https:'+pic_img.split(' ')[0]+'"><span class="option-txt">'+match_class+'</span><p class="hide_txt">'+hide_txt+'</p></label>');  
            }else{
              $('#pType').append('<label class="p-'+tClass+' '+swim_class+'" '+dd_rts+'><img src="https:'+pic_img.split(' ')[0]+'"><span class="option-txt">'+match_class+'</span><p class="hide_txt">'+hide_txt+'</p></label>');
            }
          });
          $('#pType').parents('.select-style').show();
          
          if(query != 'cotton-candy-marble'){
            if($('#pType label.selected:contains("cotton")').length > 0){
              var cot_txt =  $('#pType label:contains("cotton").selected').find('.hide_txt').text().replace(/-cotton/, '');
              var repl_txt = $('#pType label:contains("cotton").selected').find('.option-txt').text().replace(/ cotton/, '');

              if($( "#pType label:visible:contains('"+cot_txt+"')" ).length > 0){
                $('.fabric_buttons').show();
                $('#js-variant-radio-button-cotton').attr('checked','checked');

                $('#pType label.selected .option-txt').text(repl_txt);
                $( "#pType label:visible:contains('"+cot_txt+"')" ).hide();
                $('#js-variant-radio-button-polyester').click(function(){
                  $( "#pType label:contains('"+cot_txt+"')" ).trigger('click');
                });
              }
            }else{
              $('#pType label:visible').each(function(){
                if($(this).attr('class').indexOf('cotton') >= 0){
                  var click_label = $(this);
                  var cot_txt =  $(this).find('.hide_txt').text().replace(/-cotton/, '');
                  if($( "#pType label.selected:contains('"+cot_txt+"')" ).length > 0){
                    $('.fabric_buttons').show();
                    //                    $('#js-variant-radio-button-polyester').attr('checked','checked');
                    $(click_label).hide();
                    $('#js-variant-radio-button-cotton').click(function(){
                      $(click_label).trigger('click')
                    });
                  }
                }
              });
            }
          }
          
          if($('.options.swim-option').length <= 0){
            $('.other_option .click_open,.other_option .selected.icon-checkmark').click(function(){
              $('.product-right-bottom-dd .select-options').toggleClass('select-options-hover');
            });
            $(document).click(function(event) {
              if ( !$(event.target).hasClass('select-style') && $(event.target).parents(".select-style").length === 0) {
                $('.other_option.select-options.select-options-hover').removeClass('select-options-hover');
              }
            });
          }
          $('#pType label').click(function(e){
            e.preventDefault();
            if($(this).hasClass('selected')){
              return;
            }
            var dropText = $.trim($(this).find('span').text().toLowerCase());
            var findClass = $.trim($(this).attr('class'));
            
            if($(this).hasClass('classic_swim') || $(this).hasClass('high_legged') ){
              findClass = findClass.replace(" classic_swim", "");
              findClass = findClass.replace(" high_legged", "");
            }
            $('#extra_img').find('.'+findClass).each(function(){
              
              if($.trim($(this).find('.title').text().toLowerCase()) == dropText ){
                $(this).find('a').trigger('click');
                return false;
              }
            });
          });
        },
        'error': function(err){
          //console.log(err);
        }
      });

      //Restyling select dropdowns
      $.fn.selectReplace = function(leaveLabel){
        return $(this).filter('select:not(.replaced, .noreplace)').each(function(){
          //Add formatting containers
          var $opts = $(this).find('option');
          var initialText = $opts.filter(':selected').length > 0 ? $opts.filter(':selected').text() : $opts.first().text();
          var $cont = $(this).addClass('replaced').wrap('<div class="pretty-select">').parent().addClass('id-'+$(this).attr('id'))
          .append('<span class="text"><span class="value">' + initialText + '</span></span><i class="icon-arrow3-down"></i>');
          //Label? Move inside
          if($(this).attr('id')) {
            //Find label
            var $label = $('label[for="'+$(this).attr('id')+'"]');
            //If table cells used for layout, do not move the label
            var $selectTD = $(this).closest('td');
            var $labelTD = $label.closest('td');
            if(!leaveLabel && ($selectTD.length == 0 || $labelTD.length == 0 || $selectTD[0] == $labelTD[0])) {
              //Add to dropdown
              $cont.find('.text').prepend($label);
              //Add colon, if it doesn't exist
              if($label.slice(-1) != ':') {
                $label.append(':');
              }
            }
          }
        }).on('change keyup', function(){
          $(this).siblings('.text').find('.value').html($(this).find(':selected').html());
        });
      };
      
//       return $.ajax({
//         'type': 'GET',
//         'url': 'https://beloved-proxy.herokuapp.com/swiftype.json',
//         'data': {
//           'q': "\"" + query + "\""
//         }
//       }).done(function(data) {
//         var records, ref;
//         if (_.keys(data.errors).length > 0) {
//           reject(data.errors);
//           return;
//         }
//         records = (ref = data.records) != null ? ref.page : void 0;
//         if ((records != null) && records.length > 0) {
//           resolve(records);
//           return;
//         }
//         reject('Records key is empty');
//       }).fail(function(jqXHR) {
//         return reject(_.get(jqXHR, 'responseText', 'unknown error'));
//       });
      
      
    });
  };

  getProducts = function(records) {
    var promises;
    promises = _.chain(records).filter(function(record) {
      return record.type === 'product';
    }).reject(function(record) {
      return record.url.replace(shopUrl, '') === ("/products/" + productHandle);
    }).map(function(record) {
      return new Promise(function(resolve) {
        return $.getJSON(record.url).done(function(responseData) {
          return resolve(responseData.product);
        }).fail(function() {
          return resolve(null);
        });
      });
    }).value();
    return Promise.all(promises);
  };

  renderProducts = function(products) {
    var renderedItems, templates;
    if (products.length === 0) {
      return;
    }
    templates = {
      productThumb: _.get(window.beloved, 'templates.productThumb', null),
      alsoAvailable: _.get(window.beloved, 'templates.alsoAvailable', null)
    };
    renderedItems = _.chain(products).compact().map(function(product) {
      var ref, ref1, ref2, ref3;
      return {
        title: product.title,
        url: "/products/" + product.handle,
        placeholder: (ref = window.beloved) != null ? (ref1 = ref.theme_settings) != null ? ref1.lazyload_placeholder : void 0 : void 0,
        image: (ref2 = window.Shopify) != null ? (ref3 = ref2.Image) != null ? ref3.getSizedImageUrl(product.image.src, 'large') : void 0 : void 0,
        priceMin: '$' + _.chain(product.variants).map(function(variant) {
          return variant.price;
        }).uniq().value()[0]
      };
    }).map(function(item) {
      return templates.productThumb(item);
    }).take(5).value();
    $('#js-also-available').html(templates.alsoAvailable({
      products: renderedItems
    }));
  };

  getSwiftypeResults().then(function(records) {
    return getProducts(records);
  }).then(function(products) {
    return renderProducts(products);
  })["catch"](function(error) {
    return console.log(error);
  });

}).call(this);
;

(function() {
  'use strict';

  /* Display recently viewed products */
  var _, cookieName, createList, createNewCookie, currentHandle, delimiter, maxItems, productHandles, productPromises, ref, ref1;

  _ = window.belovedLodash;

  cookieName = "beloved_viewed";

  delimiter = "~";

  maxItems = 5;

  currentHandle = (ref = window.beloved) != null ? (ref1 = ref.product) != null ? ref1.handle : void 0 : void 0;

  createList = function() {
    var recent;
    recent = (function() {
      var cookieContent;
      cookieContent = $.cookie(cookieName);
      if (_.isString(cookieContent)) {
        return cookieContent.split(delimiter);
      } else {
        return [];
      }
    })();
    return _.chain(recent).reject(function(item) {
      return item === currentHandle;
    }).filter(function(item, index) {
      return index < maxItems;
    }).sortBy(function(item, index) {
      return -index;
    }).value();
  };

  createNewCookie = function(handles) {
    var newCookieContent;
    newCookieContent = _.union([currentHandle], handles).join(delimiter);
    return $.cookie(cookieName, newCookieContent, {
      expires: 90,
      path: "/"
    });
  };

  if (currentHandle == null) {
    return;
  }

  productHandles = createList();

  createNewCookie(productHandles);

  if (productHandles.length === 0) {
    return;
  }

  productPromises = _.chain(productHandles).map(function(handle) {
    return new Promise(function(resolve) {
      return $.getJSON("/products/" + handle + ".json").done(function(data) {
        return resolve(data.product);
      }).fail(function() {
        return resolve({});
      });
    });
  }).value();

  Promise.all(productPromises).then(function(products) {
    var renderedItems, templates;
    templates = {
      productThumb: _.get(window.beloved, 'templates.productThumb', null),
      recentlyViewed: _.get(window.beloved, 'templates.recentlyViewed', null)
    };
    renderedItems = _.chain(products).reject(function(product) {
      return _.isEmpty(product);
    }).map(function(product) {
      var ref2, ref3, ref4, ref5;
      return {
        title: product.title,
        url: "/products/" + product.handle,
        placeholder: (ref2 = window.beloved) != null ? (ref3 = ref2.theme_settings) != null ? ref3.lazyload_placeholder : void 0 : void 0,
        image: (ref4 = window.Shopify) != null ? (ref5 = ref4.Image) != null ? ref5.getSizedImageUrl(product.image.src, 'large') : void 0 : void 0,
        priceMin: (function() {
          if (_.includes(_.kebabCase(product.product_type), 'museum')) {
            return 'In The Museum';
          }
          return '$' + _.chain(product.variants).map(function(variant) {
            return variant.price;
          }).uniq().value()[0];
        })()
      };
    }).map(function(item) {
      return templates.productThumb(item);
    }).value();
    if (renderedItems.length === 0) {
      return;
    }
    $('#js-recently-viewed').html(templates.recentlyViewed({
      products: renderedItems
    }));
  })["catch"](function(error) {
    return console.log(error);
  });

}).call(this);
;

(function() {
  'use strict';

  /* Init lightbox effect for featured image on product page */
  var createInlinePopup;
  
  $('.js-product-images .js-featured-image').click(function(e){
    e.preventDefault();
    var cmp = $(this).attr('href');
    $('.image_popup').find('a[href*="'+cmp+'"]').trigger('click');
  });
  
  if($('.image_popup').length > 0){
    $('.image_popup').magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled:true
      },
      image: {
        verticalFit: false
      }
    });
  }else{
    $('.js-product-images .js-featured-image').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      image: {
        verticalFit: false
      }
    });
  }

  createInlinePopup = function(triggerSelector) {
    var pageContent, pageTitle;
    pageTitle = $(triggerSelector).attr('data-page-title') || '';
    pageContent = $(triggerSelector).attr('data-page-content') || '';
    return $(document.createElement('div')).attr({
      "class": 'Page is-popup'
    }).append($(document.createElement('div')).addClass('Page-title').text(pageTitle)).append($(document.createElement('div')).addClass('Page-content').html(pageContent));
  };

  $('.js-page-popup').magnificPopup({
    items: {
      src: createInlinePopup('.js-page-popup'),
      type: 'inline'
    },
    preloader: false
  });

}).call(this);
;

(function() {
  'use strict';

  /* Show YouTube video in a lightbox */
  var _, getVideoParams, normalizeYouTubeLinks, videoLinks;

  _ = window.belovedLodash;

  videoLinks = $('.js-youtube-video-lightbox');

  if (videoLinks.length === 0) {
    return;
  }

  getVideoParams = function(element) {
    var link, provider, url, videoId;
    link = $(element);
    url = new URI(link.attr('href'));
    provider = (function() {
      if (_.includes(url.hostname(), 'youtu.be')) {
        return 'youtubeShort';
      }
      if (_.includes(url.hostname(), 'youtube.com')) {
        if (_.includes(url.path(), 'embed')) {
          return 'youtubeEmbed';
        }
        return 'youtube';
      }
      return '';
    })();
    videoId = (function() {
      if (provider === 'youtube') {
        return _.get(url.search(true), 'v', '');
      }
      if (provider === 'youtubeShort') {
        return url.segment(-1);
      }
      if (provider === 'youtubeEmbed') {
        return url.segment(-1);
      }
      return '';
    })();
    return {
      provider: provider,
      id: videoId
    };
  };

  normalizeYouTubeLinks = function(element, videoParams) {
    if (videoParams.id && _.includes(videoParams.provider, 'youtube')) {
      $(element).attr('href', "https://www.youtube.com/watch?v=" + videoParams.id);
    }
  };

  videoLinks.each(function(index, element) {
    return normalizeYouTubeLinks(element, getVideoParams(element));
  });

  if (!$.fn.magnificPopup) {
    return;
  }

  videoLinks.magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

}).call(this);
;

(function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  /* Render collection video banner from YouTube video */
  var _, renderCollectionVideoBanner;

  _ = window.belovedLodash;

  renderCollectionVideoBanner = function(placeholder) {
    var videoID, videoURL;
    videoURL = placeholder.attr('data-youtube-video') || '';
    if (!videoURL) {
      return;
    }
    videoID = (function() {
      var url;
      url = new URI(videoURL);
      if (_.includes(url.path(), 'watch')) {
        return _.get(url.search(true), 'v', '');
      }
      if (_.includes(url.hostname(), 'youtu.be')) {
        return url.filename();
      }
      if (_.includes(url.path(), 'embed')) {
        return url.filename();
      }
      return '';
    })();
    if (!videoID) {
      //console.log('No YouTube video ID found');
      placeholder.addClass('is-hidden');
      $('#js-collection-banner').removeClass('is-hidden');
      return;
    }
    placeholder.css('background-image', ["url('", 'https://img.youtube.com/vi/', videoID, '/maxresdefault.jpg', "')"].join('')).append($(document.createElement('div')).attr({
      id: 'js-video-' + videoID
    }));
    window.onYouTubeIframeAPIReady = function() {
      var onPlayerReady, onPlayerStateChange, player;
      placeholder.closest('.js-slide').append($(document.createElement('div')).attr({
        id: 'js-video-poster-' + videoID,
        "class": 'CollectionVideoBanner-videoPoster'
      }).css('background-image', ["url('", 'https://img.youtube.com/vi/', videoID, '/maxresdefault.jpg', "')"].join('')));
      onPlayerReady = function(event) {
        event.target.setPlaybackQuality('default');
        event.target.mute();
        event.target.playVideo();
      };
      onPlayerStateChange = function(event) {

        /* Loop video */
        if (event.target.getPlayerState() === 0) {
          event.target.playVideo();
          return;
        }
      };
      player = new window.YT.Player('js-video-' + videoID, {
        width: placeholder.width() + '',
        height: placeholder.height() + '',
        videoId: videoID,
        playerVars: {
          autohide: 1,
          disablekb: 1,
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
          showinfo: 0
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
    };
    $('body').append($(document.createElement('script')).attr('src', 'https://www.youtube.com/iframe_api'));
  };

  renderCollectionVideoBanner($('#js-collection-video-banner'));

}).call(this);
;

(function() {
  'use strict';

  /*
   * Offcanvas related scripts
   */
  var Bacon, _, allDrawers, body, closeDrawers, openDrawer, toggleDrawer;

  _ = window.belovedLodash;

  Bacon = window.Bacon;

  allDrawers = $('.js-offcanvas');

  body = $('body');

  closeDrawers = function() {
    var bodyPosition;
    allDrawers.removeClass('is-expanded');
    bodyPosition = parseInt(body.css('top')) * -1;
    body.removeClass('has-open-offcanvas').css('top', '');
    if (_.isFinite(bodyPosition)) {
      window.requestAnimationFrame(function() {
        return $(window).scrollTop(bodyPosition);
      });
    }
  };

  openDrawer = function(evt, drawerName) {
    var selectedDrawer;
    if (drawerName === 'cart') {
      $(document).trigger('beloved:fetch_cart');
    }
    if (drawerName === 'search') {
      $('.js-offcanvas .js-swiftype-input').focus();
    }
    selectedDrawer = $(".js-offcanvas[data-drawer-names~='" + drawerName + "']");
    body.css('top', $(window).scrollTop() * -1).addClass('has-open-offcanvas');
    allDrawers.not(selectedDrawer).removeClass('is-expanded');
    selectedDrawer.addClass('is-expanded');
  };

  toggleDrawer = function(evt, drawerName, action) {
    if (drawerName == null) {
      drawerName = '';
    }
    if (action == null) {
      action = 'open';
    }
    if (!window.Modernizr.mq('(max-width: 40em)')) {
      return;
    }
    if (action === 'close') {
      $(document).trigger('beloved:hide_offcanvas');
      return;
    }
    $(document).trigger('beloved:show_offcanvas', [drawerName]);
  };

  $(document).on('beloved:hide_offcanvas', closeDrawers);

  $(document).on('beloved:show_offcanvas', openDrawer);

  $(document).on('beloved:toggle_drawer', toggleDrawer);

  Bacon.mergeAll([$(document).asEventStream('beloved:show_offcanvas'), $(window).asEventStream('resize')]).debounceImmediate(150).onValue(function() {
    return allDrawers.css('height', $(window).height() + 'px');
  });

  $('#js-offcanvas-bg').click(function() {
    $(document).trigger('beloved:hide_offcanvas');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Expand offcanvas sub-menus */
  var allSubLists, allTopLinks, wrapper, allSubLevel2Lists, allLevel2Lists;

  allTopLinks = $('.js-offcanvas-nav-top-link');

  allSubLists = $('.js-offcanvas-nav-sublist');
  
  //   by DD 23/9/20126
  allLevel2Lists = $('.js-offcanvas-nav-top-link-level2');
  
  allSubLevel2Lists = $('.js-offcanvas-nav-sublist-level2');


  wrapper = $('.js-offcanvas-content');

  allSubLists.each(function(index, element) {
    return $(element).css('height', $(element).height() + 'px').addClass('is-hidden');
  });
  
  allSubLevel2Lists.each(function(index, element) {
    return $(element).css('height', 'inherit').addClass('is-hidden');
  });

  allTopLinks.click(function(evt) {
    var listHandle, selectedLink, selectedList;
    evt.preventDefault();
    selectedLink = $(evt.delegateTarget);
    listHandle = selectedLink.attr('data-list-handle') || '';
    if (selectedLink.hasClass('is-expanded')) {
      allTopLinks.removeClass('is-expanded');
      allSubLists.addClass('is-hidden');
      return;
    }
    selectedLink.addClass('is-expanded');
    allTopLinks.not(selectedLink).removeClass('is-expanded');
    selectedList = allSubLists.filter("[data-list-handle='" + listHandle + "']");
    selectedList.removeClass('is-hidden');
    allSubLists.not(selectedList).addClass('is-hidden');
    wrapper.css('overflow-y', 'scroll');
  });
  
  allLevel2Lists.click(function(evt) {
    var listHandle, selectedLink, selectedList;
    evt.preventDefault();
    selectedLink = $(evt.delegateTarget);
    listHandle = selectedLink.attr('data-list-handle') || '';
    if (selectedLink.hasClass('is-expanded')) {
      allLevel2Lists.removeClass('is-expanded');
      allSubLevel2Lists.addClass('is-hidden');
      return;
    }
    selectedLink.addClass('is-expanded');
    allLevel2Lists.not(selectedLink).removeClass('is-expanded');
    selectedList = allSubLevel2Lists.filter("[data-list-handle='" + listHandle + "']");
    selectedList.removeClass('is-hidden');
    allSubLevel2Lists.not(selectedList).addClass('is-hidden');
    wrapper.css('overflow-y', 'scroll');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Fetch Instagram pics using Instafeed */
  var _, clientID, clients, container, fakeImage, initialURL, renderHTML;

  _ = window.belovedLodash;

  fakeImage = 'https://placeholdit.imgix.net/~text?txtsize=14&txt=150%C3%97150&w=150&h=150&fm=jpg';

  container = $('#js-instagram');

  if (container.length === 0) {
    return;
  }

  clients = ["bce1b05ee8bc4532af16d50379188f82", "a5bbab29827e449982b3f4f4c4a36ccb"];

  clientID = _.sample(clients);

  renderHTML = function(items) {
    var blockGrid, render, renderedItems, title;
    title = $(document.createElement('h4')).attr({
      'class': 'title'
    }).text(container.attr('data-instagram-title'));
    blockGrid = $(document.createElement('ul')).attr({
      'class': 'small-block-grid-3 medium-block-grid-6'
    });
    renderedItems = _.map(items, function(item) {
      var image, link;
      link = $(document.createElement('a')).attr({
        'class': 'InstagramFeed-link',
        'title': _.escape(item.caption.text),
        'href': item.link,
        'data-link': item.link,
        'target': '_blank'
      });
      image = $(document.createElement('div')).attr({
        'class': 'InstagramFeed-imagePlaceholder lazyload',
        'data-sizes': 'auto',
        'data-bgset': [_.get(item, 'images.thumbnail.url', fakeImage) + ' 150w', _.get(item, 'images.low_resolution.url', fakeImage) + ' 320w'].join(',')
      });
      return $(document.createElement('li')).attr({
        'class': 'InstagramFeed-item'
      }).append(link.append(image));
    });
    render = $(document.createElement('div')).append(title).append(blockGrid.append(renderedItems));
    return container.html(render);
  };

  initialURL = ['https://api.instagram.com/v1/users/244192886/media/recent', "?client_id=" + clientID, '&count=12', '&callback=?'].join('');

  $.ajax({
    url: initialURL,
    dataType: "jsonp",
    jsonp: true
  }).done(function(instagram) {
    var items;
    items = instagram.data;
    return renderHTML(items);
  }).fail(function() {
    return console.error("Instagram fetch error");
  });

}).call(this);
;

(function() {
  'use strict';

  /* Show newsletter pop-up window */
  var _, cookieName, createCookie, hideNotification, popup, successNotification;

  _ = window.belovedLodash;

  popup = $('#js-newsletter-popup');

  if (popup.length === 0) {
    return;
  }

  cookieName = "beloved_newsletter_popup";

  createCookie = function() {
    return $.cookie(cookieName, 'done', {
      expires: 3,
      path: "/"
    });
  };

  hideNotification = function(element) {
    return $(element).velocity({
      p: 'fadeOut',
      o: {
        duration: 400,
        easing: 'easeInOut'
      }
    });
  };

  if (_.isString($.cookie(cookieName))) {
    popup.addClass('is-hidden');
    return;
  }

  if (_.includes(window.location.search, 'customer_posted=true')) {
    popup.addClass('is-hidden');
    createCookie();
    //console.log("Customer created successfully");
    successNotification = $(document.createElement('div')).attr({
      'id': 'js-newsletter-popup-success',
      'class': 'NewsletterPopup-success'
    }).click(function(evt) {
      return hideNotification(evt.delegateTarget);
    }).text('Thank you for signing up for our newsletter');
    $('#mmenu-offcanvas').append(successNotification);
    window.setTimeout(function() {
      return hideNotification($('#js-newsletter-popup-success'));
    }, 20000);
    return;
  }

  $('#js-newsletter-popup-button').click(function(evt) {
    evt.preventDefault();
    return popup.find('#js-newsletter-popup-submit').click();
  });

  $('#js-newsletter-popup-close').click(function(evt) {
    evt.preventDefault();
    createCookie();
    return popup.addClass('is-hidden');
  });

  popup.click(function(evt) {
    if (evt.target === evt.delegateTarget) {
      createCookie();
      popup.addClass('is-hidden');
    }
  });


  /* Show popup */

  if ($('#js-newsletter-popup-error').length > 0) {
    popup.addClass('is-visible');
    return;
  }

  window.setTimeout(function() {
    return popup.addClass('is-visible');
  }, 60000);

}).call(this);
;

(function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  /* Show countdown on a slide */
  var _, addLeadingZero, adjustRelativeSize, catchedError, container, countdownTarget, error, getCountdownTarget, positionCountdown, slideshow, timeoutTimer, updateCountdownClock;

  _ = window.belovedLodash;

  timeoutTimer = '';

  addLeadingZero = function(num) {
    if (num < 10) {
      return '0' + num;
    }
    return '' + num;
  };

  slideshow = $('#js-slideshow');

  container = slideshow.find('.js-slide-countdown');

  if (container.length === 0) {
    return;
  }

  getCountdownTarget = function() {
    var countdownDate, countdownTime;
    countdownDate = container.attr('data-countdown-date') || '';
    if (!countdownDate) {
      return window.moment();
    }
    countdownTime = container.attr('data-countdown-time') || '';
    if (!countdownTime) {
      return window.moment();
    }
    return window.moment.tz(countdownDate + " " + countdownTime, 'YYYY-MM-DD HH:mm', 'America/Denver');
  };

  updateCountdownClock = function(target) {
    var difference, digits;
    if (!window.moment().isBefore(target)) {
      //console.log('Countdown target reached');
      window.clearInterval(timeoutTimer);
      return;
    }
    difference = window.moment.duration(Math.abs(window.moment().diff(target)));
    digits = _.chain([['days', difference.days()], ['hrs', difference.hours()], ['mins', difference.minutes()], ['secs', difference.seconds()]]).map(function(pair) {
      var name, value;
      name = _.first(pair);
      value = _.last(pair);
      return $(document.createElement('div')).addClass([
        'SlideCountdown-digit', (function() {
          if (name === 'days' && value === 0) {
            return 'is-hidden';
          }
          return '';
        })()
      ].join(' ')).append($(document.createElement('div')).addClass('SlideCountdown-digitValueWrapper').append($(document.createElement('div')).addClass('SlideCountdown-digitValue').text(addLeadingZero(value)))).append($(document.createElement('div')).addClass('SlideCountdown-digitName').text(name));
    }).value();
    container.html(digits);
  };

  positionCountdown = function() {
    var leftOffset, topOffset;
    topOffset = container.attr('data-position-top') || '50';
    leftOffset = container.attr('data-position-left') || '50';
    return container.css({
      top: _.trim(topOffset, ' %') + '%',
      left: _.trim(leftOffset, ' %') + '%'
    });
  };

  adjustRelativeSize = function() {
    var countdownWidth, currentRatio, scaleFactor, targetRatio;
    targetRatio = (function() {
      var ratioAttr;
      ratioAttr = container.attr('data-size-ratio') || 5;
      return _.round(ratioAttr * 1, 4);
    })();
    if (!_.isFinite(targetRatio)) {
      //console.log('Target ratio for countdown is not a number');
      return;
    }
    if (targetRatio === 0) {
      //console.log('Target ratio for countdown can\'t be zero');
      return;
    }

    /* Countdown width should match CSS value in pixels */
    countdownWidth = 630;
    currentRatio = slideshow.width() / countdownWidth;
    scaleFactor = _.round(currentRatio / targetRatio, 6);
    //console.log("Countdown scale factor: " + scaleFactor);
    container.velocity({
      p: {
        scaleX: scaleFactor,
        scaleY: scaleFactor
      },
      o: {
        duration: 100,
        easing: 'easeInOut'
      }
    });
  };

  adjustRelativeSize();

  $(window).resize(_.throttle(adjustRelativeSize, 200));

  try {
    countdownTarget = getCountdownTarget();
    positionCountdown();
    timeoutTimer = window.setInterval(function() {
      return updateCountdownClock(countdownTarget);
    }, 1000);
    container.velocity({
      p: {
        opacity: 1
      },
      o: {
        duration: 500,
        delay: 1100,
        easing: 'easeIn'
      }
    });
  } catch (error) {
    catchedError = error;
    //console.log(catchedError);
  }

}).call(this);
;
// 18-11-2016
(function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  /* Show countdown on a slide */
  var _, addLeadingZeroXmas, adjustRelativeSizeXmas, catchedErrorXmas, containerXmas, countdownTargetXmas, errorXmas, getCountdownTargetXmas, positionCountdownXmas, slideshowXmas, timeoutTimerXmas, updateCountdownClockXmas;

  _ = window.belovedLodash;

  timeoutTimerXmas = '';

  addLeadingZeroXmas = function(num) {
    if (num < 10) {
      return '0' + num;
    }
    return '' + num;
  };

  
  containerXmas = $('.IndexXmasDisclaimer').find('.js-slide-countdown');

  if (containerXmas.length === 0) {
    return;
  }

  getCountdownTargetXmas = function() {
    var countdownDate, countdownTime;
    countdownDate = containerXmas.attr('data-countdown-date') || '';
    if (!countdownDate) {
      return window.moment();
    }
    countdownTime = containerXmas.attr('data-countdown-time') || '';
    if (!countdownTime) {
      return window.moment();
    }
    return window.moment.tz(countdownDate + " " + countdownTime, 'YYYY-MM-DD HH:mm', 'America/Denver');
  };

  updateCountdownClockXmas = function(target) {
    var difference, digits;
    if (!window.moment().isBefore(target)) {
      //console.log('Countdown target reached');
      window.clearInterval(timeoutTimerXmas);
      return;
    }
    difference = window.moment.duration(Math.abs(window.moment().diff(target)));
    digits = _.chain([['days', difference.days()], ['hrs', difference.hours()], ['mins', difference.minutes()], ['secs', difference.seconds()]]).map(function(pair) {
      var name, value;
      name = _.first(pair);
      value = _.last(pair);
      return $(document.createElement('div')).addClass([
        'SlideCountdown-digit', (function() {
          if (name === 'days' && value === 0) {
            return 'is-hidden';
          }
          return '';
        })()
      ].join(' ')).append($(document.createElement('div')).addClass('SlideCountdown-digitValueWrapper').append($(document.createElement('div')).addClass('SlideCountdown-digitValue').text(addLeadingZeroXmas(value)))).append($(document.createElement('div')).addClass('SlideCountdown-digitName').text(name));
    }).value();
    containerXmas.html(digits);
  };

  try {
    countdownTargetXmas = getCountdownTargetXmas();
    timeoutTimerXmas = window.setInterval(function() {
      return updateCountdownClockXmas(countdownTargetXmas);
    }, 1000);
    containerXmas.velocity({
      p: {
        opacity: 1
      },
      o: {
        duration: 500,
        delay: 1100,
        easing: 'easeIn'
      }
    });
  } catch (error) {
    catchedError = error;
    //console.log(catchedError);
  }
  
}).call(this);
;

(function() {
  'use strict';

  /* Custom Product Image Upload and Manipulation */
  var _, activateButtons, activateThumb, addDefaultImage, addImageToCanvas, canvases, getScaleFactor, imageOptions, removeImage, resizeCanvas, showThumbs, throttledResize, updateThumbImage, uploadImage, widget, zoomImage;

  _ = window.belovedLodash;

  if (window.filepicker == null) {
    return;
  }

  if (window.fabric == null) {
    return;
  }

  widget = $('#js-custom-product-widget');

  if (widget.length === 0) {
    return;
  }

  imageOptions = {
    crossOrigin: 'anonymous',
    lockUniScaling: true,
    centeredScaling: true,
    centeredRotation: true,
    cornerColor: 'rgba(44,85,107,0.9)',
    borderColor: 'rgba(44,85,107,0.9)',
    transparentCorners: false
  };

  getScaleFactor = function(canvas, canvasObject) {
    var factor;
    factor = _.first(_.sortBy([canvas.height / canvasObject.height, canvas.width / canvasObject.width], function(number) {
      return number;
    }));
    if (factor < 1) {
      return factor;
    }
    return 1;
  };

  resizeCanvas = function(canvas) {
    var canvasObjects, canvasScaleFactor, oldObjectParams;
    canvasObjects = canvas.getObjects() || [];
    oldObjectParams = _.map(canvasObjects, function(canvasObject) {
      return {
        scaleX: canvasObject.get('scaleX'),
        top: canvasObject.get('top'),
        left: canvasObject.get('left')
      };
    });
    canvasScaleFactor = (function() {
      if (canvas.getWidth() === 0) {
        return widget.width();
      }
      return widget.width() / canvas.getWidth();
    })();
    canvas.setDimensions({
      width: widget.width(),
      height: widget.width()
    });
    canvas.setBackgroundImage($(canvas.getElement()).attr('data-base'), canvas.renderAll.bind(canvas), {
      width: canvas.width,
      height: canvas.height,
      originX: 'left',
      originY: 'top',
      crossOrigin: 'anonymous'
    });
    canvas.setOverlayImage($(canvas.getElement()).attr('data-mask'), canvas.renderAll.bind(canvas), {
      width: canvas.width,
      height: canvas.height,
      originX: 'left',
      originY: 'top',
      crossOrigin: 'anonymous'
    });
    if (canvasObjects.length === 0) {
      return canvas;
    }
    _.forEach(canvasObjects, function(canvasObject, index) {
      var oldParam;
      oldParam = _.find(oldObjectParams, function(value, oldIndex) {
        return oldIndex === index;
      });
      if (!oldParam) {
        return;
      }
      canvasObject.scale(oldParam.scaleX * canvasScaleFactor);
      canvasObject.set('top', _.round(oldParam.top * canvasScaleFactor));
      canvasObject.set('left', _.round(oldParam.left * canvasScaleFactor));
      canvasObject.setCoords();
    });
    canvas.setActiveObject(_.first(canvasObjects));
    return canvas;
  };

  removeImage = function(canvas, section) {
    var currentImage;
    currentImage = _.first(canvas != null ? canvas.getObjects() : void 0);
    if (!currentImage) {
      return;
    }
    canvas.remove(currentImage);
    $(canvas.getElement()).attr('data-custom-image', '');
    section.find('[data-canvas-action="remove"]').addClass('is-hidden');
    section.find('.fileName').removeClass('is-hidden');
    section.find('[data-canvas-action="upload"]').removeClass('is-hidden');
    section.find('[data-canvas-action|="zoom"]').addClass('is-hidden');
  };

  zoomImage = function(canvas, action) {
    var currentImage, zoomFactor;
    currentImage = _.first(canvas != null ? canvas.getObjects() : void 0);
    if (!currentImage) {
      return;
    }
    zoomFactor = (function() {
      if (action === 'zoom-in') {
        return 1.1;
      }
      if (action === 'zoom-out') {
        return 0.9091;
      }
      //console.log('CPW Warning: zoom action is not defined');
      return 1;
    })();
    currentImage.setScaleX(currentImage.getScaleX() * zoomFactor).setScaleY(currentImage.getScaleY() * zoomFactor).setCoords();
    canvas.renderAll().setActiveObject(currentImage);
  };

  addImageToCanvas = function(Blob, canvas) {
    var currentObjects;
    currentObjects = canvas.getObjects() || [];
    if (currentObjects.length > 0) {
      _.forEach(currentObjects, function(object) {
        return canvas.remove(object);
      });
    }
    $(canvas.getElement()).attr('data-custom-image', Blob.url);
    return window.fabric.Image.fromURL(Blob.url + '/convert?w=1024&h=1024&fit=max', function(oImg) {
      oImg.scale(getScaleFactor(canvas, oImg) * 0.8);
      canvas.add(oImg).centerObject(oImg);
      oImg.setCoords();
      return canvas.renderAll().setActiveObject(oImg);
    }, imageOptions);
  };

  uploadImage = function(canvas, section) {
    $(document).trigger('beloved:open_filepicker');
    window.filepicker.setKey("AEyhwiIOSKShcXiBg7Y1mz");
    return window.filepicker.pickAndStore({
      multiple: false,
      maxFiles: 1,
      folders: false,
      mimetype: 'image/*',
      services: ['COMPUTER', 'INSTAGRAM', 'FACEBOOK', 'DROPBOX', 'SKYDRIVE', 'GOOGLE_DRIVE']
    }, {}, function(Blobs) {
      addImageToCanvas(_.first(Blobs), canvas);
      section.find('[data-canvas-action="remove"]').removeClass('is-hidden');
      section.find('.fileName').addClass('is-hidden');
      $('.img-error').remove();
      section.find('[data-canvas-action="upload"]').addClass('is-hidden');
      section.find('[data-canvas-action|="zoom"]').removeClass('is-hidden');
    }, function(FPError) {
      return console.log(FPError.toString());
    });
  };

  activateButtons = function(canvas) {
    var section;
    section = $(canvas.getElement()).parents('.js-custom-product-section');
    section.find('[data-canvas-action="upload"]').click(function() {
      return uploadImage(canvas, section);
    });
    section.find('[data-canvas-action="remove"]').click(function() {
      return removeImage(canvas, section);
    });
    section.find('[data-canvas-action|="zoom"]').click(function(evt) {
      return zoomImage(canvas, $(evt.delegateTarget).attr('data-canvas-action'));
    });
    return canvas;
  };

  showThumbs = function() {
    var thumbsWrapper;
    thumbsWrapper = $(document.createElement('div')).attr({
      "class": 'CustomProductWidget-thumbs'
    });
    widget.append(thumbsWrapper);
    if (canvases.length === 1) {
      thumbsWrapper.addClass('is-hidden');
    }
    return canvases.each(function(index, element) {
      var baseImage, sectionName;
      sectionName = $(element).attr('data-section');
      baseImage = $(element).attr('data-base');
      if (!baseImage) {
        return;
      }
      
      var tempsec = sectionName;
      if($('#product-10631528018').length>0 && sectionName == 'back' ){
        tempsec = 'Side';
      }
      thumbsWrapper.append($(document.createElement('div')).attr({
        "class": 'js-custom-product-thumb CustomProductWidget-thumb',
        'data-section': sectionName
      }).append($(document.createElement('div')).attr({
        "class": ['js-custom-product-thumb-image', 'CustomProductWidget-thumbImagePlaceholder'].join(' ')
      }).css('background-image', "url('" + baseImage + "')").append($(document.createElement('div')).addClass('CustomProductWidget-thumbText').text(tempsec))));
    });
  };

  updateThumbImage = function() {
    canvases.each(function(index, element) {
      var canvas, renderedImage, sectionName;
      canvas = $(element).data('fabricCanvas');
      sectionName = $(element).attr('data-section');
      if (!canvas) {
        return;
      }
      canvas.discardActiveObject();
      renderedImage = canvas.toDataURL({
        format: 'jpeg',
        quality: 0.9,
        multiplier: 0.5
      });
      widget.find(".js-custom-product-thumb[data-section='" + sectionName + "']").find('.js-custom-product-thumb-image').css('background-image', "url('" + renderedImage + "')");
    });
  };

  activateThumb = function(evt) {
    var allSections, sectionName, thumb;
    evt.preventDefault();
    thumb = $(evt.delegateTarget);
    sectionName = thumb.attr('data-section');
    updateThumbImage();
    allSections = widget.find('.js-custom-product-section');
    allSections.not(".is-" + sectionName).addClass('is-hidden');
    allSections.filter(".is-" + sectionName).first().removeClass('is-hidden');
  };

  addDefaultImage = function(canvas) {
    var canvasElement, defImage;
    canvasElement = $(canvas.getElement());
    defImage = {
      url: canvasElement.attr('data-default-image') || '',
      scaleFactor: (function() {
        var scaleFactor;
        scaleFactor = 1 * canvasElement.attr('data-default-image-scale');
        if (_.inRange(scaleFactor, 0.1, 1)) {
          return scaleFactor;
        }
        return 0.5;
      })(),
      vFactor: (function() {
        var vFactor;
        vFactor = 1 * canvasElement.attr('data-default-image-top');
        if (_.inRange(vFactor, 0.1, 2)) {
          return vFactor;
        }
        return 1;
      })(),
      hFactor: (function() {
        var hFactor;
        hFactor = 1 * canvasElement.attr('data-default-image-left');
        if (_.inRange(hFactor, 0.1, 2)) {
          return hFactor;
        }
        return 1;
      })()
    };
    if (!defImage.url) {
      return;
    }
    window.fabric.Image.fromURL(defImage.url, function(oImg) {
      oImg.scale(getScaleFactor(canvas, oImg) * defImage.scaleFactor);
      canvas.add(oImg).centerObject(oImg);
      oImg.set('top', oImg.get('top') * defImage.vFactor).set('left', oImg.get('left') * defImage.hFactor).setCoords();
      return canvas.renderAll().setActiveObject(oImg);
    }, imageOptions);
  };


  /* Start */

  canvases = widget.find('.js-custom-product-section canvas').not('.upper-canvas');

  canvases.each(function(index, element) {
    var canvas;
    canvas = new window.fabric.Canvas($(element).attr('id'), {
      backgroundColor: '#fff',
      controlsAboveOverlay: true
    });
    $(element).data('fabricCanvas', canvas);
    resizeCanvas(canvas);
    activateButtons(canvas);
    return addDefaultImage(canvas);
  });

  showThumbs();

  widget.find('.js-custom-product-thumb').click(activateThumb);

  throttledResize = _.throttle(function() {
    return canvases.each(function(index, element) {
      var canvas;
      canvas = $(element).data('fabricCanvas');
      if (!canvas) {
        return;
      }
      if (canvas.getWidth() === widget.width()) {
        return;
      }
      resizeCanvas(canvas);
    });
  }, 150);

  $(window).resize(throttledResize);

}).call(this);
;

(function() {
  'use strict';

  /* Intercom events */
  $(document).on('beloved:cart_add', function() {
    if (!window.Intercom) {
      return;
    }
    window.Intercom('trackEvent', 'added-product-to-cart');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Adjust JuicerFeed look after load */
  var replaceImageWithPlaceholder;

  replaceImageWithPlaceholder = function(index, element) {
    var image, imageSrc;
    image = $(element).find('img');
    imageSrc = image.attr('src') || '';
    image.wrap($(document.createElement('div')).css('background-image', "url('" + imageSrc + "')").addClass('JuicerFeed-imagePlaceholder'));
    image.addClass('JuicerFeed-hiddenImage');
    $(element).addClass('has-placeholder');
  };

  window.juicerAfterRender = function() {
    $('.juicer-feed .j-image').not('.has-placeholder').each(replaceImageWithPlaceholder);
  };

}).call(this);
;

(function() {
  'use strict';

  /* Update shipping motivator */
  var Bacon, _, cartTotal, cookieName, getRegion, motivator, provider, region, templates;

  _ = window.belovedLodash;

  Bacon = window.Bacon;

  provider = 'https://freegeoip.net/json/?callback=?';

  cookieName = 'beloved_geo';

  motivator = $('#js-free-shipping-motivator .top-bar-left');

  if (motivator.length === 0) {
    return;
  }

  templates = _.reduce(['domestic', 'international', 'canada'], function(acc1, prefix) {
    acc1[prefix] = _.reduce(['initial', 'progress', 'success'], function(acc2, suffix) {
      acc2[suffix] = _.template(_.get(window, "beloved.theme_settings.fsm_" + prefix + "_" + suffix, '').replace('<%', '<%='));
      return acc2;
    }, {});
    return acc1;
  }, {});

  getRegion = (function() {
    var cookieContent;
    cookieContent = $.cookie(cookieName);
    if (_.isString(cookieContent)) {
      return Bacon.once(cookieContent);
    }
    return Bacon.fromPromise($.getJSON(provider)).map(function(data) {
      var countryCode;
      countryCode = _.get(data, 'country_code', '');
      if (countryCode == 'US') {
        return 'domestic';
      }else if (countryCode == 'CA') {
        return 'canada';
      }else{
        return 'international';
      }
    }).mapError('domestic');
  })();

  region = getRegion.toProperty('domestic');
  
  cartTotal = $(document).asEventStream('beloved:cart', function(evt, data) {
    return _.get(data, 'total_price', 0) / 100;
  }).debounceImmediate(300).toProperty(0);


  /* Actions */

  region.onValue(function(value) {
    return $.cookie(cookieName, value, {
      expires: 1,
      path: "/"
    });
  });
  
  Bacon.combineTemplate({
    region: region,
    total: cartTotal
  }).onValue(function(info) {
    var render;
    render = (function() {
      var messageType, targetAmount, template;
      targetAmount = _.get(window, "beloved.theme_settings.fsm_" + info.region + "_target", '200') * 1;
      messageType = (function() {
        if (info.total === 0) {
          return 'initial';
        }
        if (info.total >= targetAmount) {
          return 'success';
        }
        return 'progress';
      })();
      template = _.get(templates, info.region + "." + messageType, null);
      if (template) {
        return template({
          amount: '$' + _.round(targetAmount - info.total * 1, 2)
        });
      }
      return 'Error';
    })();
    var targetAmount = _.get(window, "beloved.theme_settings.fsm_" + info.region + "_target", '200') * 1;
    var amount= '$' + _.round(targetAmount - info.total * 1, 2);
    render = render.replace("AMOUNT", amount);
    return motivator.text(render);
  });

}).call(this);
;

(function() {
  'use strict';

  /* Activate tag filter dropdown on blog page */
  $('#tag_filter').change(function() {
    return window.location = $('#tag_filter option:selected').val();
  });


  /* Submit cart form on cart page when qty is changed */

//   $("#cart_form input[type='number']").change(function() {
//     return $("#cart_form").submit();
//   });


  /* Expand sections in sidebar */

  $('.toggle').click(function(evt) {
    var $toggle;
    if ($(window).width() > 767) {
      return;
    }
    $toggle = $(evt.delegateTarget);
    if ($toggle.next('ul').is(':visible')) {
      $toggle.next('ul').hide();
      $toggle.children('span').html('+');
      return;
    }
    $toggle.next('ul').show();
    $toggle.children('span').html('-');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Initialize observers on address selectors */
  var _, currentTemplate, customerAddressIds;

  _ = window.belovedLodash;

  currentTemplate = _.get(window, 'beloved.currentTemplate', '');

  customerAddressIds = _.get(window, 'beloved.customer_address_ids', []);

  if (!_.includes(currentTemplate, 'addresses')) {
    return;
  }

  new window.Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
    hideElement: 'address_province_container_new'
  });

  _.forEach(customerAddressIds, function(addressId) {
    return new window.Shopify.CountryProvinceSelector("address_country_" + addressId, "address_province_" + addressId, {
      hideElement: "address_province_container_" + addressId
    });
  });

  $('.js-shopify-toggle-new-address-form').click(function() {
    window.Shopify.CustomerAddress.toggleNewForm();
    return false;
  });

  $('.js-shopify-toggle-address-form').click(function(evt) {
    window.Shopify.CustomerAddress.toggleForm($(evt.delegateTarget).attr('data-form-id'));
    return false;
  });

}).call(this);
;

(function() {
  'use strict';

  /* Show/hide recover password form */
  var currentTemplate, ref, showRecoverPasswordForm;

  currentTemplate = ((ref = window.beloved) != null ? ref.currentTemplate : void 0) || '';

  if (currentTemplate.indexOf('login') < 0) {
    return;
  }

  showRecoverPasswordForm = function() {
    $('#recover-password').show();
    $('#login_form').hide();
  };

  if (window.location.hash === '#recover') {
    showRecoverPasswordForm();
  }

}).call(this);
;

(function() {
  'use strict';

  /* BuyX app code */
  var hideLabels;

  hideLabels = function() {
    return $("label:contains('BuyXDiscount')").hide();
  };

  setTimeout(hideLabels, 100);

  setTimeout(hideLabels, 200);

  setTimeout(hideLabels, 300);

  setTimeout(hideLabels, 500);

  setTimeout(hideLabels, 1000);

  return;

}).call(this);
;

(function() {
  'use strict';

  /* Send Facebook events */
  if (typeof window.fbq !== "function") {
    return;
  }

  $(document).on('beloved:cart_add', function() {
    return window.fbq('track', 'AddToCart');
  });

  $(document).on('beloved:search_results', function() {
    return window.fbq('track', 'Search');
  });

  $(document).on('click', 'a[href^="/checkout"]', function() {
    return window.fbq('track', 'InitiateCheckout');
  });

  $('form[action="/cart"]').submit(function() {
    return window.fbq('track', 'InitiateCheckout');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Init shipping calculator */
  var currentTemplate, ref, ref1, ref2, ref3, ref4, ref5, showCalculator;

  currentTemplate = ((ref = window.beloved) != null ? ref.currentTemplate : void 0) || '';

  showCalculator = (ref1 = window.beloved) != null ? (ref2 = ref1.theme_settings) != null ? ref2.show_shipping_calculator : void 0 : void 0;

  if (currentTemplate.indexOf('cart') < 0) {
    return;
  }

  if (!showCalculator) {
    return;
  }

  if ($('#shipping-calculator').length === 0) {
    return;
  }

  if ((ref3 = window.Shopify) != null) {
    if ((ref4 = ref3.Cart) != null) {
      if ((ref5 = ref4.ShippingCalculator) != null) {
        ref5.show({
          submitButton: 'Calculate shipping',
          submitButtonDisabled: 'Calculating...',
          moneyFormat: "${{amount}} USD"
        });
      }
    }
  }

}).call(this);
;

(function() {
  'use strict';

  /* Activate BuyXCartCheck */
  $(document).on('beloved:cart', function(evt, cart) {
    if (typeof window.BuyXCartCheck === "function") {
      window.BuyXCartCheck(cart);
    }
  });

}).call(this);
;

(function() {
  'use strict';
  var initSwitcher, lazyLoad, newArrivals;

  newArrivals = window.beloved.fn.newArrivals;

  lazyLoad = window.beloved.fn.lazyLoad;


  /* Index Swithcer */

  initSwitcher = function() {
    return $('.IndexSwitcher a').off('click').on('click', function(event) {
      
      if(!jQuery('.js-index.IndexWomen').find('#front-women').length){
        var html = $('#front-women').html();
        $('#front-women').remove();
        jQuery('.js-index.IndexWomen .IndexThemeList').after('<div class="nosto_element" id="front-women">'+html+'</div>');
      }
      if(jQuery(window).width() > 641){
        jQuery('.mobile-dd').remove();
        jQuery('.desk-dd').show();
      } else {
        jQuery('.desk-dd').remove();
        jQuery('.mobile-dd').show();
      }
      var url;
      event.preventDefault();
      event.stopPropagation();
      url = $(this).attr('href');
      $('.js-index').hide();
      $('.js-index[data-url="' + url + '"]').show();
    });
  };


  initSwitcher();

  $(function() {
    return $(".IndexWomen").load("/pages/women .IndexWomen section", function() {
      initSwitcher();
      lazyLoad.init();
      return newArrivals.init('.IndexWomen .js-new-arrivals', 'newArrivals:women');
    });
  });

}).call(this);

(function() {
  $('.bulk-price').magnificPopup({
    items: {
      src: '#bulk-price-popup',
      type: 'inline'
    },
    preloader: false,
    modal: false
  });
  
}).call(this);
(function() {
  $('.photo_popup').magnificPopup({
    items: {
      src: '#photo-popup',
      type: 'inline'
    },
    preloader: false,
    modal: false
  });
  
  $('.design-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  $('.design-slider').show();
  $(window).resize();
  
  $('.design-slider').magnificPopup({
    delegate: 'a',
    type: 'image',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0,1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      titleSrc: function(item) {
        return 'WHAT OTHER PEOPLE HAVE CREATED';
      }
    }
  });
  
  $('.contact_btn').magnificPopup({
    items: {
      src: '#contact-popup',
      type: 'inline'
    },
    preloader: false,
    modal: false
  });
  
  $('.imglowclick').magnificPopup({
    items: {
      src: '#img-low',
      type: 'inline'
    },
    preloader: false,
    modal: false
  });
  
  $(document).on('click', '.popup-modal-btn', function (e) {
    e.preventDefault();
    $('#fileUpload').val('');
    $('.fileName').text('No file chosen');
    $.magnificPopup.close();
  });
  
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
  
}).call(this);
(function() {
  $('.image-popup-vertical-fit').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });
  $('.product-right-tabs ul li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.product-right-tabs ul li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
}).call(this);
(function() {
  jQuery('.slickslide').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: false,
    slide: 'li',
    cssEase: 'linear',
    centerMode: true,
    slidesToShow: 1,
    variableWidth: true,
    autoplay: false,
    autoplaySpeed: 4000,
    responsive: [{
      breakpoint: 800,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        variableWidth: false,
        slidesToShow: 1,
        dots: true
      },
      breakpoint: 1200,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        variableWidth: false,
        slidesToShow: 1,
        dots: true

      }
    }],
    customPaging: function (slider, i) {
      return '<button class="tab">' + $('.slick-thumbs li:nth-child(' + (i + 1) + ')').html() + '</button>';
    }
  });
  
  $('.slickslide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    setTimeout(function(){
      var name=$('.slick-dots').find('li[aria-hidden="false"] button').html();
      $('.pastmonth-title .monthname').html(name);
    },200);
  });
  
}).call(this);
(function() {
  $('.purgepopup').magnificPopup({
    items: {
      src: '#purge_content',
      type: 'inline'
    },
    preloader: false,
    modal: false
  });
  
}).call(this);

(function() {
  $('.slickslid-pop').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 5,
    autoplay: false,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4        
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

  });  
}).call(this);
// 13-1-2017 for infinite scroll
(function() {
  'use strict';
  bind_click();
  function bind_click(){
    $('.IndexFeaturedCollection .next').click(function(e){
      $(this).addClass('showSpin');
      e.preventDefault();
      $.ajax({
        type: 'GET',
        url: $(this).attr('href'),
        success: function(data){
          var filteredData = $(data).find(".infinit_load").html();
          var pageData = $(data).find(".pagination").html();
          $(".infinit_load").append(filteredData);
          $(".pagination").html(pageData);
          bind_click();
        }
      });
    });
  }
}).call(this);
//2017-03-10 for clear cart
(function() {
  $('#clear-cart').click(function() {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function(data) {
        if(data.item_count == 0){
          window.location = "/cart";
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        window.location = "/cart";
      }
    });
  });
}).call(this);
// for protabs
(function() {
  window.popupCartAbroadClient = false;
  window.popupCartCanadaClient = false;
  geoipUrl = 'https://freegeoip.net/json/';
  $.ajax({
    type: "get",
    url: geoipUrl,
    success: function(result) {
      var ccode = result.country_code;
      if(ccode == 'CA'){
        var motval = $('.motivator.cart-motivator').attr('data-motivator-limit-canada');
        $('.motivator.cart-motivator').attr('data-motivator-limit',motval);
        $('.motivator.cart-motivator').attr('data-motivator-limit-abroad',motval);
        return window.popupCartCanadaClient = result.country_code;
      }else if(ccode !== 'US'){
        var motval = $('.motivator.cart-motivator').attr('data-motivator-limit-abroad');
        $('.motivator.cart-motivator').attr('data-motivator-limit',motval);
        $('.motivator.cart-motivator').attr('data-motivator-limit-canada',motval);
        return window.popupCartAbroadClient = result.country_code;
      }
    }
  });
}).call(this);
function ajx_popup() {
 
  if(jQuery('#ship_date').length >= 0){
    function calcTime(dt,offset) {
      var d = dt;
      var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
      var nd = new Date(utc + (3600000 * offset));
      // return time as a string
      return nd;
    }

    jQuery('.see_info').click(function(){
      jQuery('#ship_info').toggleClass('hide');
    });
    jQuery(document).on("click" , function(event){  
      if(jQuery(event.target).attr("class") != "see_info")
      {
        jQuery('#ship_info').addClass('hide');
      }
    });
    
     jQuery('.see_details').click(function(){
       jQuery('#detail_info').toggleClass('hide');
     });
    jQuery(document).on("click" , function(event){  
      if(jQuery(event.target).attr("class") != "see_details")
      {
        jQuery('#detail_info').addClass('hide');
      }
    });

    var text = $('.agree_pod_lable').text();
    if(text){
      var number = parseFloat(text.match(/-*[0-9]+/));
      getEndDate(number);
    }else{
      jQuery('.shipby').remove();
      //var number = 10;
    }  
    function getEndDate(days){
      var numAdd = days
      var dataAvui = calcTime(new Date(),'-7');
      var month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";

      for (var i = 0; i <= numAdd; i++)
      {
        var dataTemp = dataAvui
        if(i == numAdd){
          jQuery('#ship_date').html(month[dataTemp.getMonth()]+' '+dataTemp.getDate());
        }
        dataTemp.setDate(dataTemp.getDate() + 1)
        if (dataTemp.getDay() == 6) {
          dataTemp.setDate(dataTemp.getDate() + 2)
        } else if (dataTemp.getDay() == 0) {
          dataTemp.setDate(dataTemp.getDate() + 1)
        }
        dataAvui = dataTemp
      }
    }
  }

  
  'use strict';

  /* Toggle product description tabs */
  var initProductDescTab, tabContents, tabs;

  tabs = $('.js-product-tab');

  tabContents = $('.js-product-tab-content');

//   if (tabs.length === 0 && tabContents.length === 0) {
//     return;
//   }

  initProductDescTab = function(evt) {
    var tab, tabContent, tabHandle;
    tab = $(evt.delegateTarget);
    tabHandle = tab.attr('data-tab-handle');
    tabContent = tabContents.filter("[data-tab-handle='" + tabHandle + "']");
    if (tabContent.length === 0) {
      return;
    }
    tabs.not(tab).removeClass('is-active');
    tabContents.not(tabContent).removeClass('is-active').velocity({
      p: 'slideUp',
      o: {
        duration: 300,
        easing: 'easeInOut'
      }
    });
    tab.addClass('is-active');
    tabContent.addClass('is-active').velocity({
      p: 'slideDown',
      o: {
        duration: 300,
        easing: 'easeInOut'
      }
    });
  };

  tabs.click(initProductDescTab);

  
  /* Init AJAX Cart popup */
  var geoipUrl, refreshCartPopup, showCartPopup, submitCart, showCartPopupCustom, submitCartCustom, countDiscount, showCartPopupBundle;

    if (!$.browser.mobile || screen.width >= 640) {
    var drFlag = 0;
    refreshCartPopup = function(callback) {
      return $.getJSON('/cart.json').done(function(cart) {
        var limit, limit_left, message, motivator;
//         motivator = $('.js-ajax-cart-popup .motivator');
        if($('#cartprogress-desk').length > 0){
          motivator = $('.cart-motivator.motivator');
        }
        
        $('#cd-cart .inner_shadow').empty();
        var drawer_html = '';

        if(cart.item_count > 0){
          var j = 0;
          var t2 = 0;
          var t3 = 0;
          var qt = 0;
          var c_price = 0;
          
          $(cart.items).each(function (idx) {
            var vID = this.id;

            $.ajax({
              url: '/products/'+this.handle+'.js',
              type: 'GET',
              async: false,
              success: function(prod){
                var found_price = $.grep(prod.variants, function(v) {
                  return v.id === vID;
                });
                c_price = found_price[0].compare_at_price;
              },
              error: function(resp){
                var prod = JSON.parse(resp.responseText);
                var found_price = $.grep(prod.variants, function(v) {
                  return v.id === vID;
                });
                c_price = found_price[0].compare_at_price;
              }
            });

            var price = this.discounted_price ? this.discounted_price : this.price;
            var qty = this.quantity;
            var temp = this.original_price * qty;
            var discount = this.discounts && this.discounts[0] ? this.discounts[0].title : '';

            if (this.vendor.indexOf("Custom") > -1) {
              var vol = true;
              var maintemp2 = price * qty;
              var comptemp2 = this.original_price * qty;
              t3 = t3 + maintemp2;
              t2 = t2 + comptemp2;
            }
            
            if(this.vendor == "Custom"){
              qt += Number(this.quantity);
            }
            
            j = j + temp;

            drawer_html +='<div class="right_cart_list remove_'+this.id+'"><div class="right_cart_img">';
            drawer_html +='<img src="'+this.image+'"></div>';
            drawer_html +='<div class="right_cart_text"><h4>'+this.title.split('-')[0]+'</h4>';
            if(this.variant_options[0] != 'Default Title'){
            	drawer_html +='<p class="size">'+this.variant_options[0]+'</p>';
            }
            drawer_html +='<p><a href="javascript:void(0)">x '+ qty + ' @ ' + window.Shopify.formatMoney(price) + ' ';
            drawer_html +='<del>' + window.Shopify.formatMoney(c_price) + '</del> ';
            drawer_html +='<span class="discount-message">' + discount + '</span></a></p></div>';

            drawer_html +='<div class="right_cart_rmv"><div class="rmv_item" data-varId="'+this.id+'">X</div></div></div>';

            if(parseFloat(idx) == parseFloat(cart.items.length-1)){
              drawer_html +='<div class="subtotal">Subtotal: '+window.Shopify.formatMoney(cart.total_price)+'</div>';
              $('#cd-cart .inner_shadow').html(drawer_html);
              
              if(!$('.right_cart_custm').hasClass('speed-in') && drFlag == 1){
                $('#cd-cart-trigger').trigger('click');
              }
              
              drFlag = 1;
              
              $('.rmv_item').click(function(){
                var itid = $(this).attr('data-varId');
                jQuery.ajax({
                  type: "POST",
                  url: '/cart/change.js',
                  data : 'quantity=0&id='+itid,
                  success: function(result) {
                    drFlag = 0;
                    $('.remove_'+itid).remove();
                    refreshCartPopup();
                  },
                  error: function(){
                    drFlag = 0;
                    $('.remove_'+itid).remove();
                    refreshCartPopup();
                  }
                });
              });
            }
          });
          
          if($('#cartprogress-desk').length > 0){
            $('#cartprogress-desk').show();
            motivator.show();
          }
        }else{
          $('#cd-cart .inner_shadow').html('<h4 class="no_item">You have no items in cart.</h4>');
          if($('#cartprogress-desk').length > 0){
            $('#cartprogress-desk').hide();
            motivator.hide();
          }
          drFlag =1;
        }
        
        $('.js-cart-count').html(cart.item_count);
        $('.js-subtotal-value').html(window.Shopify.formatMoney(cart.total_price));
        
        if($('#cartprogress-desk').length > 0){
          
          var prog = $(".deskcart-drawer");
          var total_price = cart.total_price * 100;
          var limit = $('.motivator.cart-motivator').attr('data-motivator-limit'); 
          var get_per = total_price / limit;
          var maxwidth = get_per.toFixed(2);
          
          if(maxwidth < 100){
            prog.animate({width:+maxwidth+'%'}, 1000)		
          } else {
            prog.animate({width:"100%"}, 1000)
          }
          
          if(qt > 0){
            var price1 = [];
            if (typeof localStorage["price1"] != 'undefined'){
              price1 = JSON.parse(localStorage["price1"]);
//               callDiscount();
            }else{
              onDomIsRendered("#shappify-qty-msg table").then(function(element){
                $('#shappify-qty-msg').find('tbody tr').each(function(){
                  var qtytd1 = $(this).find('td:first-child').text();
                  var pricetd1 = $(this).find('td:last-child').text();
                  price1.push({"qtytd": qtytd1 ,"pricetd": pricetd1 });
                });
                localStorage["price1"] = JSON.stringify(price1);
//                 callDiscount();
              });
            }
            if(!$.isEmptyObject(price1)){
              var original_p = price1[0].pricetd.split('$')[1];
              jQuery(price1).each(function(obj){
                if(qt < $(this)[0].qtytd){
                  var p = $(this)[0].pricetd.split('$')[1];
                  var temp = parseFloat((100*p)/original_p);
                  $('.motivator').html('Add '+ Number($(this)[0].qtytd-qt) +' more to save '+ Math.ceil(100-temp)+'%');
                  $('.motivator').show();
                  return false;
                }
              });
            }
          }else{
            limit = motivator.data('motivator-limit');
            
            if (limit < cart.total_price) {
              motivator.html('<span>'+motivator.data('message-reached')+'</span>');
            } else {
              limit_left = window.Shopify.formatMoney(limit - cart.total_price);
              message = motivator.data('message').replace('LIMIT', limit_left);
              motivator.html(message);
            }
          }
          
        }
        if (typeof callback === 'function') {
          return callback();
        }
      });
    };
    refreshCartPopup();
    submitCart = function(form) {
      return $.ajax({
        type: "POST",
        url: form.attr('action'),
        data: form.serialize(),
        success: function() {
          if (typeof(upsell_main) === "function") {
            upsell_main();
          }
          if (typeof(upsell_offer) === "function") { 
            upsell_offer(); 
            jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
              $('.js-add-to-cart').removeClass('showSpin');
              $('.js-add-to-cart').find('.ProductForm-submitButtonText').text('ADDED');
              $('.js-cart-count').removeClass('is-hidden');
              $("html, body").animate({ scrollTop: 0 }, "slow");
              return refreshCartPopup(function() {
                $('.js-ajax-cart-popup').show();
                return setTimeout(function() {
                  return $('.js-ajax-cart-popup').attr('style', '');
                }, 5000);
              });
            });
          } else { 
            $('.js-add-to-cart').removeClass('showSpin');
            $('.js-add-to-cart').find('.ProductForm-submitButtonText').text('ADDED');
            $('.js-cart-count').removeClass('is-hidden');
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return refreshCartPopup(function() {
//               $('.js-ajax-cart-popup').show();
//               return setTimeout(function() {
//                 return $('.js-ajax-cart-popup').attr('style', '');
//               }, 5000);
            });
          }
        }
      });
    };
    showCartPopup = function(e) {
      if($('.fabric_buttons:visible .ProductRadioButtons-item .ProductRadioButtons-itemRadio').length > 0){
        var fbname = $('.fabric_buttons .ProductRadioButtons-item .ProductRadioButtons-itemRadio').attr('name');
        if(!$("input:radio[name="+fbname+"]").is(":checked")){
          $('.fabric_buttons.ProductRadioButtons').after('<p class="swatch-error"><span class="icon-checkmark"></span> <span>Please select the fabric option.</span></p>');
          return false;
        }else{
          $('.swatch-error').remove();
        }
      }
      
      if($('.size_buttons .ProductRadioButtons-item .ProductRadioButtons-itemRadio').length > 0){
        var rdname = $('.size_buttons .ProductRadioButtons-item .ProductRadioButtons-itemRadio').attr('name');
        if(!$("input:radio[name="+rdname+"]").is(":checked")){
          $('.size_buttons.ProductRadioButtons').after('<p class="swatch-error"><span class="icon-checkmark"></span> <span>Please select the size option.</span></p>');
          return false;
        }else{
          $('.swatch-error').remove();
        }
      }
      
      //dd-ack
      if(ack_enable){
        if($('#agree_pod_check:visible').length >0 && !$('#agree_pod_check').is(':checked')){
          $('.agree_pod_lable').css('color','#FF0400');
          $('.pod-error').show();
          return false;
        }else{
          $('.agree_pod_lable').removeAttr('style');
          $('.pod-error').hide();
        }
      }
      $('.js-add-to-cart').addClass('showSpin');
      var _, form, renderCustomMockups;
      e.preventDefault();
      e.stopPropagation();
      form = $(e.target).parents('form');
      _ = window.belovedLodash;
      renderCustomMockups = _.get(window, 'beloved.fn.renderCustomMockups', null);
      if ($('#js-custom-product-widget').length) {
        return renderCustomMockups(form).then(function(blobs) {
          if (_.filter(blobs, 'url').length === 0) {
            return Promise.reject({
              description: 'Please upload your image(s) first'
            });
          }
          return submitCart(form);
        });
      } else {
        return submitCart(form);
      }
    };
    //     Added By DD-11/7/2016
    submitCartCustom  = function(form) {
      var length = form.find('.qtyy').length;
      var toAdd = new Array();
      var qty;
      var i=0;

      for(i=0; i < length; i++){
        toAdd.push({
          variant_id: $("#variant-"+i).val(),        
          quantity_id: $("#quantity-"+i).val() || 0,
          custom_img1: $("#custom_image_1").val(),
          mockup_img1: $("#custom_mockup_1").val(),
          custom_img2: $("#custom_image_2").val(),
          mockup_img2: $("#custom_mockup_2").val(),
          shipping_text: $('#shipping_text').val(),
          design_note: $('.design-note').val()
        });
      } 
      function moveAlong(){
        if (toAdd.length) {
          var request = toAdd.shift();
          var tempId= request.variant_id;
          var tempQty = request.quantity_id;
          var customImage1 = request.custom_img1;
          var mockupImage1 = request.mockup_img1;
          var customImage2 = request.custom_img2;
          var mockupImage2 = request.mockup_img2;
          var shipText = request.shipping_text;
          var designNote = request.design_note;
          var dta ='';

          if(customImage2 != ''){
            dta = 'quantity='+tempQty+'&id='+tempId+'&properties%5BUsually+ships+within%5D='+shipText+'&properties%5Bcustom_image_1%5D='+customImage1+'&properties%5Bcustom_mockup_1%5D='+mockupImage1+'&properties%5Bcustom_image_2%5D='+customImage2+'&properties%5Bcustom_mockup_2%5D='+mockupImage2;
          }else{
            dta = 'quantity='+tempQty+'&id='+tempId+'&properties%5BUsually+ships+within%5D='+shipText+'&properties%5Bcustom_image_1%5D='+customImage1+'&properties%5Bcustom_mockup_1%5D='+mockupImage1;
          }
          
          if(designNote != ''){
          	dta += '&properties%5BDesign+note%5D='+designNote;
          }

          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: dta,
            dataType: 'json',
            success: function(line_item) { 
              moveAlong();
            },
            error: function() {
              moveAlong();
            }
          };
          $.ajax(params);
        }
        else {    
          $('.js-add-to-cart').removeClass('showSpin');
          $('.js-add-to-cart').find('.ProductForm-submitButtonText').text('ADDED');
          $('.js-cart-count').removeClass('is-hidden');
          $("html, body").animate({ scrollTop: 0 }, "slow");
          return refreshCartPopup(function() {
//             $('.js-ajax-cart-popup').show();
//             return setTimeout(function() {
//               return $('.js-ajax-cart-popup').attr('style', '');
//             }, 5000);
          });
//           window.location.href = "/cart";
        }  
      };
      moveAlong();
    };
    showCartPopupCustom = function(e) {
      var setqty = 0;
      var form = $(e.target).parents('form');
      $(".qtyy").each(function( index ) {
        if($(this).val() > 0){
          	setqty = 1;	
        }
	  });
      if(setqty == 0){
      	$('.ProductRadioButtons').after('<p class="swatch-error"><span class="icon-checkmark"></span> <span>Please add quantity one of them.</span></p>'); 	
      	return false;
      }
      if(setqty == 1) {
      	$('p.swatch-error').hide();
      }
      
      if($('#good_pic').length >0 && !$('#good_pic').is(':checked')){
        $('.agree_good_pic_label').css('color','#FF0400');
        $('.good_pic_error').show();
        return false;
      }else{
        $('.agree_good_pic_label').removeAttr('style');
        $('.good_pic_error').hide();
      }
      
      //dd-ack
      if(ack_enable){
        if($('#agree_pod_check:visible').length >0 && !$('#agree_pod_check').is(':checked')){
          $('.ProductRadioButtons p.swatch-error').hide();
          $('.agree_pod_lable').css('color','#FF0400');
          $('.pod-error').show();
          return false;
        }else{
          $('.ProductRadioButtons p.swatch-error').hide();
          $('.agree_pod_lable').removeAttr('style');
          $('.pod-error').hide();
        }
      }
      $('.js-add-to-cart').addClass('showSpin');
      var _, form, renderCustomMockups;
      e.preventDefault();
      e.stopPropagation();
      form = $(e.target).parents('form');
      _ = window.belovedLodash;
      renderCustomMockups = _.get(window, 'beloved.fn.renderCustomMockups', null);
      if ($('#js-custom-product-widget').length) {
        return renderCustomMockups(form).then(function(blobs) {
          if (_.filter(blobs, 'url').length === 0) {
            $('.js-add-to-cart').removeClass('showSpin');
            $('.js-cart-count').removeClass('is-hidden');
            $('.CustomProductWidget-button').first().after('<p class="img-error">Please upload your image here.</p>');
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return Promise.reject({
              description: 'Please upload your image(s) first'
            });
          }
          return submitCartCustom(form);
        });
      } else {
        return submitCartCustom(form);
      }
    };
//     Added for bundle by DD
    showCartPopupBundle = function(e) {
      //dd-ack
      if(ack_enable){
        if($('#agree_pod_check:visible').length >0 && !$('#agree_pod_check').is(':checked')){
          $('.agree_pod_lable').css('color','#FF0400');
          $('.pod-error').show();
          return false;
        }else{
          $('.agree_pod_lable').removeAttr('style');
          $('.pod-error').hide();
        }
      }
      $('.js-add-to-cart').addClass('showSpin');
      var _, form, renderCustomMockups;
      e.preventDefault();
      e.stopPropagation();
      var toAdd = new Array();
      jQuery('.child-products').each(function(){
        var pid = jQuery(this).find('select').val();
        toAdd.push({
          variant_id: pid
        });
      });
      function moveAlong(){
        if (toAdd.length) {
          var request = toAdd.shift();
          var tempId= request.variant_id;
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: 'quantity=1&id='+tempId,
            dataType: 'json',
            success: function(line_item) {
              moveAlong();
            },
            error: function() {
              moveAlong();
            }
          };
          $.ajax(params);
        }
        else {    
          if (typeof(upsell_main) === "function") {
            upsell_main();
          }
          if (typeof(upsell_offer) === "function") { 
            upsell_offer(); 
            jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
              $('.js-add-to-cart').removeClass('showSpin');
              $('.js-add-to-cart').find('.ProductForm-submitButtonText').text('ADDED');
              $('.js-cart-count').removeClass('is-hidden');
              $("html, body").animate({ scrollTop: 0 }, "slow");
              return refreshCartPopup(function() {
                $('.js-ajax-cart-popup').show();
                return setTimeout(function() {
                  return $('.js-ajax-cart-popup').attr('style', '');
                }, 5000);
              });
            });
          } else { 
            $('.js-add-to-cart').removeClass('showSpin');
            $('.js-add-to-cart').find('.ProductForm-submitButtonText').text('ADDED');
            $('.js-cart-count').removeClass('is-hidden');
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return refreshCartPopup(function() {
              $('.js-ajax-cart-popup').show();
              return setTimeout(function() {
                return $('.js-ajax-cart-popup').attr('style', '');
              }, 5000);
            });
          }
        }  
      };
      moveAlong();
    };
    
    $(function() {
//       refreshCartPopup();
      if($('.js-add-to-cart').hasClass('cusom-cart')){
        return $('.js-add-to-cart').off('click').on('click', showCartPopupCustom);
      }else if($('.js-add-to-cart').hasClass('bundle_add')){
        return $('.js-add-to-cart').off('click').on('click', showCartPopupBundle);
      }else{
        return $('.js-add-to-cart').off('click').on('click', showCartPopup);
      }
    });
  }
  else{
    cart_drawer();
  }
  /* Show YouTube video in a lightbox */
  var _, getVideoParams, normalizeYouTubeLinks, videoLinks;

  _ = window.belovedLodash;
  setTimeout(function(){
    var purl = window.location.href;
    if($('.size_buttons .ProductRadioButtons-item .ProductRadioButtons-itemRadio').length > 0){
      jQuery('.size_buttons .ProductRadioButtons-item .ProductRadioButtons-itemLabel').click(function(){
        jQuery('.agree_pod_div').show();
        jQuery('.swatch-error').hide();
      });
    }else{
      jQuery('.agree_pod_div').show();
    }
  },1000);
  
  $('.js-size-chart-link-no-thumb').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });
  $('.js-size-chart-link').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });
  
  $('.product-right-bottom-dd .product-img a').each(function(){
    if($(this).hasClass('active')){
      return;
    }
    if($('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length <= 0 && $('#extra_img').find('.'+$.trim($(this).attr('class'))+'-cotton a').length <= 0 ) {
      $(this).addClass('dd-hide');
    }
  });
  
  $('.product-right-tabs .tab-content').removeClass('current');
  $('.product-right-tabs ul').find('li').removeClass('current');
  
  $('.product-right-tabs .tab-content').each(function(){
    if($(this).find('.active').length > 0){
      $(this).addClass('current');
      $('.product-right-tabs ul').find('li[data-tab='+$(this).attr('id')+']').addClass('current');
    }
    if($(this).find('a').length != $(this).find('.dd-hide').length){
      $('.product-right-tabs ul').find('li[data-tab='+$(this).attr('id')+']').css('display','inline-block');
    }
  });
  $('.product-right-tabs').show();
  
  $('.product-right-tabs ul li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.product-right-tabs ul li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  
  $('.product-right-bottom-dd .product-img a').click(function(e){
    e.preventDefault();
    if($(this).hasClass('active')){
      return;
    }
    var top_url = $(location).attr('href'); 

    if(top_url.indexOf('women')>0){
      if($('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length > 0){
        $('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').first().trigger('click');
      }else{
        $('#extra_img').find('.'+$.trim($(this).attr('class'))+'-cotton a').first().trigger('click');
      }
    }else{
      var thisClass = $.trim($(this).attr('class'));
      var a_lgth = 0;

      if($('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length > 0){
        a_lgth = $('#extra_img').find('.'+$.trim($(this).attr('class'))+' a').length -1 ;
      }
      var common_class = $.trim($(this).attr('class'));

      $('#extra_img').find('div[class*="'+common_class+'"] a').each(function(i){

        if($(this).find('span').text().indexOf(' men')>0 || $(this).find('span').text().indexOf(' Men')>0){
          $(this).trigger('click');
          return false;
        }else if(i == a_lgth) {

          if($('#extra_img').find('.'+thisClass+' a').length > 0){
            $('#extra_img').find('.'+thisClass+' a').first().trigger('click'); 
          }else{
            $('#extra_img').find('.'+thisClass+'-cotton a').first().trigger('click'); 
          }
        }
      });
    }
  });
  
  var tempi = 0;
  var productTitle = _.get(window, 'beloved.product.title', '') || '';
  var query;
  query =_.kebabCase(productTitle).replace(/-adult/, '').replace(/-men.?s/, '').replace(/-women.?s/, '').replace(/-kid.?s/, '').replace('-pocket-tee', '').replace('-tee', '').replace('-belovesie', '').replace('-sweatshirt', '').replace('-shirt', '').replace('-muscle-tank', '').replace('-tank', '').replace('-croptop', '').replace('-zip-up', '').replace('-hoodie', '').replace('-raglan-sleeves', '').replace('-men-raglan', '').replace('-sleeves', '').replace('-raglan', '').replace('-leggings', '').replace('-v-neck', '').replace('-bucket-hat', '').replace('-hat', '').replace('-necklace', '').replace('-crew-socks', '').replace('-crew-tee', '').replace('-socks', '').replace('-sublimated', '').replace('-pillow-case', '').replace('-pillow', '').replace('-pillows', '').replace('-blanket', '').replace('-i-phone-case', '').replace('-case', '').replace('-ring', '').replace('-mask', '').replace('-joggers', '').replace('-jogger', '').replace('-free', '').replace('-yoga-pants', '').replace('-yoga-mat', '').replace('-pants', '').replace('-ready-to-ship', '').replace('custom', '').replace('-top', '').replace('-high-tops','').replace('-highs','').replace('-cotton','').replace('-apron','').replace('-athletic','').replace('-board-shorts','').replace('-shorts','').replace('-canvas-wraps','').replace('-dream','').replace('-dress','').replace('-duvet-cover','').replace('-edm-gear','').replace('-fidget-spinner','').replace('-flip-flops','').replace('-graphic','').replace('-gift-card','').replace('-handbag','').replace('-jewelry','').replace('-kids','').replace('-long','').replace('-mug','').replace('-mystery-box','').replace('-notebook','').replace('-one-piece-swimsuit','').replace('-pencil','').replace('-rubber','').replace('-shower-curtain','').replace('-slippers','').replace('-snapback','').replace('-sticker','').replace('-strapback','').replace('-cap','').replace('-elite','').replace('-sunglasses','').replace('-tapestry','').replace('-tall','').replace('-throw','').replace('-tracksuit','').replace('-v-necks','').replace('-weekend','').replace('-vintage','').replace('-ts','').replace('-swim-trunks','');
  
  $('#extra_img div[class*="p-"]').each(function(){

    var pic_img = $(this).find('.ProductThumb-imagePlaceholder:first-child').attr('data-bgset').split(',')[0];
    var match_text = $('.product-img .active').attr('class').toLowerCase().split('p-')[1].split(' ')[0];

    var match_class = $.trim($(this).find('.title').text().toLowerCase());
//     if(match_class.indexOf('ready to ship') >= 0){
//       match_class = $.trim(match_class.split('-')[0]);
//     }
    var mClass = $.trim($('.Product-title.product_name.mobile_hide').text().toLowerCase());

    var thisClass = $(this).attr('class').toLowerCase();
    var tClass = thisClass.split('p-')[1].split(' ')[0];
    var appClass = '';
    var top_url = $(location).attr('href'); 
    var mencheck = 0;

    if(top_url.indexOf('women')>0){
      mencheck = 0;
    }else{
      mencheck = 1;
    }
    var swim_class ='';
    var dd_rts ='';

    var hide_txt = _.kebabCase(match_class);
    if($('#pType').hasClass('swim-option')){
      if(match_class.indexOf('high legged') >= 0 ){
        swim_class = "high_legged";
      }else{
        swim_class = "classic_swim";
      }
    }
    if(match_class.indexOf('ready to ship') >= 0 ){
      dd_rts = 'dd-rts="yes"';
	} else {
	  dd_rts = 'dd-rts="no"';
    }

    if(tClass.indexOf(match_text) >= 0){
      if(match_class == mClass && tempi == 0){
        tempi = 1;
        appClass = 'selected icon-checkmark';
      }
      $('#pType').append('<label class="'+appClass+' p-'+tClass+' '+swim_class+'" '+dd_rts+' style="display:block"><img src="https:'+pic_img.split(' ')[0]+'"><span class="option-txt">'+match_class+'</span><p class="hide_txt">'+hide_txt+'</p></label>');  
    }else{
      $('#pType').append('<label class="p-'+tClass+' '+swim_class+'" '+dd_rts+'><img src="https:'+pic_img.split(' ')[0]+'"><span class="option-txt">'+match_class+'</span><p class="hide_txt">'+hide_txt+'</p></label>');
    }
  });
  $('#pType').parents('.select-style').show();
  
  if(query != 'cotton-candy-marble'){
    if($('#pType label.selected:contains("cotton")').length > 0){
      var cot_txt =  $('#pType label:contains("cotton").selected').find('.hide_txt').text().replace(/-cotton/, '');
      var repl_txt = $('#pType label:contains("cotton").selected').find('.option-txt').text().replace(/ cotton/, '');

      if($( "#pType label:visible:contains('"+cot_txt+"')" ).length > 0){
        $('.fabric_buttons').show();
        $('#js-variant-radio-button-cotton').attr('checked','checked');

        $('#pType label.selected .option-txt').text(repl_txt);
        $( "#pType label:visible:contains('"+cot_txt+"')" ).hide();
        $('#js-variant-radio-button-polyester').click(function(){
          $( "#pType label:contains('"+cot_txt+"')" ).trigger('click');
        });
      }
    }else{
      $('#pType label:visible').each(function(){
        if($(this).attr('class').indexOf('cotton') >= 0){
          var click_label = $(this);
          var cot_txt =  $(this).find('.hide_txt').text().replace(/-cotton/, '');
          if($( "#pType label.selected:contains('"+cot_txt+"')" ).length > 0){
            $('.fabric_buttons').show();
            $('#js-variant-radio-button-polyester').attr('checked','checked');
            $(click_label).hide();
            $('#js-variant-radio-button-cotton').click(function(){
              $(click_label).trigger('click')
            });
          }
        }
      });
    }
  }
  
  $('#pType label').click(function(e){
    e.preventDefault();
    if($(this).hasClass('selected')){
      return;
    }
    var dropText = $.trim($(this).find('span').text().toLowerCase());
    var findClass = $.trim($(this).attr('class'));
    
    if($(this).hasClass('classic_swim') || $(this).hasClass('high_legged') ){
      findClass = findClass.replace(" classic_swim", "");
      findClass = findClass.replace(" high_legged", "");
    }

    $('#extra_img').find('.'+findClass).each(function(){
      if($.trim($(this).find('.title').text().toLowerCase()) == dropText ){
        $(this).find('a').trigger('click');
        return false;
      }
    });
  });
  
  if($('.options.swim-option').length <= 0){
    $('.other_option .click_open,.other_option .selected.icon-checkmark').click(function(){
      $('.product-right-bottom-dd .select-options').toggleClass('select-options-hover');
    });
    $(document).click(function(event) {
      if ( !$(event.target).hasClass('select-style') && $(event.target).parents(".select-style").length === 0) {
        $('.other_option.select-options.select-options-hover').removeClass('select-options-hover');
      }
    });
  }
  
  thumb_open();
  

  videoLinks = $('.js-youtube-video-lightbox');

  if (videoLinks.length === 0) {
    return;
  }

  getVideoParams = function(element) {
    var link, provider, url, videoId;
    link = $(element);
    url = new URI(link.attr('href'));
    provider = (function() {
      if (_.includes(url.hostname(), 'youtu.be')) {
        return 'youtubeShort';
      }
      if (_.includes(url.hostname(), 'youtube.com')) {
        if (_.includes(url.path(), 'embed')) {
          return 'youtubeEmbed';
        }
        return 'youtube';
      }
      return '';
    })();
    videoId = (function() {
      if (provider === 'youtube') {
        return _.get(url.search(true), 'v', '');
      }
      if (provider === 'youtubeShort') {
        return url.segment(-1);
      }
      if (provider === 'youtubeEmbed') {
        return url.segment(-1);
      }
      return '';
    })();
    return {
      provider: provider,
      id: videoId
    };
  };

  normalizeYouTubeLinks = function(element, videoParams) {
    if (videoParams.id && _.includes(videoParams.provider, 'youtube')) {
      $(element).attr('href', "https://www.youtube.com/watch?v=" + videoParams.id);
    }
  };

  videoLinks.each(function(index, element) {
    return normalizeYouTubeLinks(element, getVideoParams(element));
  });

  if (!$.fn.magnificPopup) {
    return;
  }

  videoLinks.magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  
}
function cart_drawer() {
  'use strict';

  /* Init AJAX Cart */
  var Bacon, Promise, _, activityStatus, addActions, allCartActions, api, cartContainer, cartData, currentTemplate, qtyActions, removeActions, renderCustomMockups, submitButtons;

  if ($.browser.mobile || screen.width < 640) {
    _ = window.belovedLodash;
    Promise = window.Promise;
    Bacon = window.Bacon;
    api = window.beloved.fn.shopifyAPI;
    renderCustomMockups = _.get(window, 'beloved.fn.renderCustomMockups', null);
    currentTemplate = _.get(window, 'beloved.currentTemplate', '');
    cartContainer = $('.js-ajax-cart-container');
    submitButtons = $('form[action^="/cart/add"] [type="submit"]');

    /* Set up event streams */
    addActions = submitButtons.asEventStream('click').flatMap(function(evt) {
      var form, mockups;
      evt.preventDefault();
      form = $(evt.delegateTarget).closest('form').first();

      /* Render custom mockups */
      if (_.includes(currentTemplate, 'product-custom')) {
        if (renderCustomMockups == null) {
          return new Bacon.Error({
            description: 'Internal code error (20160302141000)'
          });
        }
        mockups = renderCustomMockups(form).then(function(blobs) {
          if (_.filter(blobs, 'url').length === 0) {
            return Promise.reject({
              description: 'Please upload your image(s) first'
            });
          }
          return api.postForm(form);
        });
        return Bacon.fromPromise(mockups);
      }
      return Bacon.fromPromise(api.postForm(form));
    });

    removeActions = cartContainer.asEventStream('click', '.js-ajax-cart-remove').flatMap(function(evt) {
      var itemLine, link;
      evt.preventDefault();
      link = $(evt.target);
      itemLine = link.attr('data-line');
      if (itemLine == null) {
        return 'Cart line number is not defined';
      }
      link.text('Removing…');
      return Bacon.fromPromise(api.removeItem(itemLine));
    });
    qtyActions = cartContainer.asEventStream('keyup', '.js-ajax-cart-qty').debounce(500).flatMap(function(evt) {
      var field, qty, variantId;
      evt.preventDefault();
      field = $(evt.target);
      variantId = field.attr('data-id') || '';
      qty = _.parseInt(field.val()) || 1;
      if (_.isFinite(qty) && variantId) {
        return Bacon.fromPromise(api.changeQty(variantId, qty));
      }
      return new Bacon.Error({
        description: 'Internal error (20160303165600)'
      });
    });
    allCartActions = Bacon.mergeAll([addActions, removeActions, qtyActions]);

    /* Handle errors */
    allCartActions.onError(function(error) {
      return $('.js-cart-error').text(_.get(error, 'description', 'Unknown error'));
    });

    /* Update cart contents */
    cartData = Bacon.mergeAll([allCartActions, $(document).asEventStream('beloved:fetch_cart')]).flatMapLatest(function() {
      return Bacon.fromPromise(api.getCart());
    }).debounce(100);

    /* Indicate activity */
    activityStatus = Bacon.mergeAll([allCartActions.mapError('error'), $(document).asEventStream('beloved:render_mockups').map('doing'), allCartActions.map('doing'), $(document).asEventStream('beloved:open_filepicker').map('done'), $(document).asEventStream('beloved:select_variant').map('done'), cartData.map('done')]).toProperty('done');
    activityStatus.onValue(function(status) {
      if (!_.isString(status)) {
        return;
      }
      $('.js-cart-activity-status').attr('data-status', status);
      if (status !== 'error') {
        $('.js-cart-error').empty();
      }
      if (status === 'doing') {
        submitButtons.prop('disabled', true);
        return;
      }
      submitButtons.prop('disabled', false);
    });

    /* Open cart drawer when product is added */
    addActions.onValue(function() {
      if ($('body').attr('data-shopify-template') === 'collection-wholesale') {
        return;
      }
      $(document).trigger('beloved:toggle_drawer', ['cart', 'open']);
    });

    /* Init cart on page load */
    $(document).trigger('beloved:fetch_cart');
  }

}
function calcTime(dt,offset) {
    d = dt;
    utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    nd = new Date(utc + (3600000 * offset));
    // return time as a string
    return nd;
  }
function CountDownTimer(dt, id){
    var end = dt;
    
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer;

    function showRemaining() {
      var now = calcTime(new Date(),'-7');
      var distance = end - now;
      if (distance < 0) {
        clearInterval(timer);
        document.getElementById(id).innerHTML = 'EXPIRED!';
        return;
      }
      
      var days = Math.floor(distance / _day);
      var hours = Math.floor((distance % _day) / _hour);
      var minutes = Math.floor((distance % _hour) / _minute);
      var seconds = Math.floor((distance % _minute) / _second);

      document.getElementById('hours').innerHTML = hours + '<span> hrs</span>';
      document.getElementById('minutes').innerHTML = minutes + '<span> mins</span> ';
    }

    timer = setInterval(showRemaining, 1000);
  }
function thumb_open(){
    
  if($('#daily_timer').length > 0){
    var currentDate = new Date();
    var ts = new Date(currentDate.getFullYear(), currentDate.getMonth(),currentDate.getDate(),20,00,00),
        newYear = true;
    if((new Date()) > ts){
      // The new year is here! Count towards something else.
      // Notice the *1000 at the end - time must be in milliseconds
      ts = (new Date()).getTime() + 10*24*60*60*1000;
      newYear = false;
    }
    $('#daily_timer').countdown({
      timestamp	: ts,
      callback	: function(hours, minutes){
        var message = "";
        message += hours + " hour" + ( hours==1 ? '':'s' ) + ", ";
        message += minutes + " minute" + ( minutes==1 ? '':'s' ) + " and ";
      }
    });
  }
  
  
  'use strict';

  /* Activate thumbnail links on product page */
  var activateThumbLink;

  activateThumbLink = function(index, element) {
    var featuredImage, thumbLink;
    thumbLink = $(element);
    featuredImage = thumbLink.parents('.js-product-images').find('.js-featured-image');
    if (featuredImage.length === 0) {
      return;
    }
    thumbLink.click(function(evt) {
      var newImage, oldImage;
      evt.preventDefault();
      oldImage = featuredImage.find('.js-featured-image-placeholder').first();
      if (oldImage.length === 0) {
        return;
      }
      if (oldImage.attr('data-image-id') === thumbLink.attr('data-image-id')) {
        return;
      }
      newImage = $(document.createElement('div')).attr({
        'class': ['js-featured-image-placeholder', 'Product-featuredImagePlaceholder', 'lazyload', 'is-newlyAdded'].join(' '),
        'data-bgset': thumbLink.attr('data-src'),
        'data-image-id': thumbLink.attr('data-image-id'),
        'data-sizes': 'auto'
      });
      featuredImage.attr({
        'href': thumbLink.attr('href')
      }).html(newImage);
    });
  };
  
  
  $('.js-product-images .js-featured-image').click(function(e){
    e.preventDefault();
    var cmp = $(this).attr('href');
    $('.image_popup').find('a[href*="'+cmp+'"]').trigger('click');
  });


  if($('.image_popup').length > 0){
    $('.image_popup').magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled:true
      },
      image: {
        verticalFit: false
      }
    });
  }else{
    $('.js-product-images .js-featured-image').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      image: {
        verticalFit: false
      }
    });
  }
  
  $('.js-product-images .js-thumb-link').each(activateThumbLink);
}


(function() {
  /* Init slideshow on index page */
  var countdown;
  
	// Number of seconds in every time division
	var days	= 24*60*60,
		hours	= 60*60,
		minutes	= 60;
	
	// Creating the plugin
	$.fn.countdown = function(prop){
		
		var options = $.extend({
			callback	: function(){},
			timestamp	: 0
		},prop);
		
		var left, d, h, m, s, positions;

		// Initialize the plugin
		init(this, options);
		
		positions = this.find('.position');
		
		(function tick(){
			
			// Time left
			left = Math.floor((options.timestamp - (new Date())) / 1000);
          
			
			if(left < 0){
				left = 0;
			}
			
			// Number of days left
			d = Math.floor(left / days);
// 			updateDuo(0, 1, d);
			left -= d*days;
			
			// Number of hours left
			h = Math.floor(left / hours);
			updateDuo(0, 1, h);
			left -= h*hours;
          
			
			// Number of minutes left
			m = Math.floor(left / minutes);
			updateDuo(2, 3, m);
			left -= m*minutes;
          
			
			// Number of seconds left
			s = left;
// 			updateDuo(6, 7, s);
			
			// Calling an optional user supplied callback
			options.callback(h, m);
			
			// Scheduling another call of this function in 1s
			setTimeout(tick, 1000);
		})();
		
		// This function updates two digit positions at once
		function updateDuo(minor,major,value){
			switchDigit(positions.eq(minor),Math.floor(value/10)%10);
			switchDigit(positions.eq(major),value%10);
		}
		
		return this;
	};


	function init(elem, options){
		elem.addClass('countdownHolder');

		// Creating the markup inside the container
		$.each(['hrs','mins'],function(i){
			$('<span class="count'+this+'">').html(
				'<span class="position">\
					<span class="digit static">0</span>\
				</span>\
				<span class="position">\
					<span class="digit static">0</span>\
				'+this+' </span>'
			).appendTo(elem);
			
			if(this!="Seconds"){
				elem.append('<span class="countDiv countDiv'+i+'"></span>');
			}
		});

	}

	// Creates an animated transition between the two numbers
	function switchDigit(position,number){
		
		var digit = position.find('.digit')
		
		if(digit.is(':animated')){
			return false;
		}
		
		if(position.data('digit') == number){
			// We are already showing this number
			return false;
		}
		
		position.data('digit', number);
		
		var replacement = $('<span>',{
			'class':'digit',
			css:{
				top:'-2.1em',
				opacity:0
			},
			html:number
		});
		
		// The .static class is added when the animation
		// completes. This makes it run smoother.
		
		digit
			.before(replacement)
			.removeClass('static')
			.animate({top:'2.5em',opacity:0},'fast',function(){
				digit.remove();
			})

		replacement
			.delay(100)
			.animate({top:0,opacity:1},'fast',function(){
				replacement.addClass('static');
			});
	}
  
  if($('#daily_timer').length > 0){
    var currentDate = new Date();
    var ts = new Date(currentDate.getFullYear(), currentDate.getMonth(),currentDate.getDate(),20,00,00),
        newYear = true;
    if((new Date()) > ts){
      // The new year is here! Count towards something else.
      // Notice the *1000 at the end - time must be in milliseconds
      ts = (new Date()).getTime() + 10*24*60*60*1000;
      newYear = false;
    }
    $('#daily_timer').countdown({
      timestamp	: ts,
      callback	: function(hours, minutes){
        var message = "";
        message += hours + " hour" + ( hours==1 ? '':'s' ) + ", ";
        message += minutes + " minute" + ( minutes==1 ? '':'s' ) + " and ";
      }
    });
  }
 
  
}).call(this);
;

// (function() {
 
// }).call(this);

$(window).load(function() {
  var ddHref = $('.js-featured-image.Product-featuredImageLink').attr('dd-href');
  $('.js-featured-image.Product-featuredImageLink').attr('href',ddHref);
                                                         
});